<template>
  <div id="weather-map-wrapper" :class="{'is-embedded': $root.$data.embedded}">
    <div class="zoom-indicator">Zoom: {{ currentZoom }}</div>
    <div
      v-show="hoverTooltip.visible"
      class="hover-tooltip"
      :style="{left: hoverTooltip.x + 'px', top: hoverTooltip.y + 'px'}"
    >
      {{ hoverTooltip.text }}
    </div>
    <div
      v-show="panoramaHover.visible"
      class="panorama-hover"
      :style="{
        left: panoramaHover.x + 'px',
        top: panoramaHover.y + 'px'
      }"
      @mouseenter="keepPanoramaHover"
      @mouseleave="scheduleHidePanoramaHover"
      @click.stop="openHoverPanorama"
    >
      <img src="@/assets/icons/360-image.png" alt="Panorama 360" />
    </div>

    <div ref="map3dweather" id="weather-map-container" :class="{'weather-enabled': weatherActive}"></div>
    <div v-if="layerSFEnabled && projectWmtsConfig" class="sf-overlay-control" @click="toggleProjectWmtsLayer">
      <img src="@/assets/icons/sf.png" alt="Layer SF" />

      <div>Layer SF</div>
    </div>
    <button id="routing-button" @click="startRouting">Routing</button>
    <RoutingService v-if="routingEnabled" :kml-url="kmlUrl" @routeLoaded="onRouteLoaded" @error="onRoutingError" />
  </div>
</template>

<script>
import M2wApi from "@/services/m2w_api";
import {initMTKMap, getMTKMap, destroyMTKMap} from "@/services/map/mtkMapManager";
import Vue from "vue";
import sfLayerImage from "@/assets/icons/sf.png";
// import convertPoisToGeoJSON from "@/convertPoisToGeoJSON";

const DBG = {
  init: true,
  events: true,
  camera: true
};

const TAG = "WeatherMTK";
// const log = {
//   start: (what, extra = {}) => console.groupCollapsed(`%c[${TAG}] ▶ ${what}`, "color:#0af", extra),
//   ok: (msg, extra = {}) => console.log(`%c[${TAG}] ✓ ${msg}`, "color:#0a0", extra),
//   warn: (msg, extra = {}) => console.warn(`[${TAG}] ⚠ ${msg}`, extra),
//   err: (msg, extra = {}) => console.error(`[${TAG}] ✖ ${msg}`, extra),
//   end: () => console.groupEnd(),
// };
const log = {
  start: (what, extra = {}) => console.groupCollapsed(`%c[${TAG}] ▶ ${what}`, "color:#0af", extra),

  ok: (msg, extra = {}) => console.log(`%c[${TAG}] ✓ ${msg}`, "color:#0a0", extra),

  warn: (msg, extra = {}) => console.warn(`[${TAG}] ⚠ ${msg}`, extra),

  err: (msg, extra = {}) => console.error(`[${TAG}] ✖ ${msg}`, extra),

  feature: feature => {
    console.log(`%c[${TAG}] FEATURE TEST 1`, "color:#ff9800;font-weight:bold", {
      id: feature?.properties?.id,
      name: feature?.properties?.name,
      width: feature?.properties?.width,
      line_width: feature?.properties?.line_width,
      line_color: feature?.properties?.line_color,
      geometry: feature?.geometry?.type,
      short_info: feature?.properties?.short_info,
      url_360: feature?.properties?.url_360,
      properties: feature?.properties
    });
  },

  end: () => console.groupEnd()
};

const DAYTIME_I18N = {
  ro: {
    today: "Astăzi",
    tomorrow: "Mâine",
    months: [
      "Ianuarie",
      "Februarie",
      "Martie",
      "Aprilie",
      "Mai",
      "Iunie",
      "Iulie",
      "August",
      "Septembrie",
      "Octombrie",
      "Noiembrie",
      "Decembrie"
    ]
  },
  de: {
    today: "Heute",
    tomorrow: "Morgen",
    months: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ]
  },
  en: {
    today: "Today",
    tomorrow: "Tomorrow",
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  }
};

export default {
  /* eslint-disable prettier/prettier */
  /* eslint-disable no-undef */
  // /* global MTK */

  name: "WeatherMTK",
  props: {
    lat: {type: Number, required: true},
    lng: {type: Number, required: true},
    zoom: {type: Number, default: 0},
    poisGeoJSON: {type: Object, default: null},
    startWithWeather: {type: Boolean, default: false},
    projectId: {type: [String, Number], default: null},
    hideUi: {type: Boolean, default: false}
  },
  data() {
    return {
      map: null,
      routingEnabled: false,
      isWeatherLayerMounted: false,
      flightAnimation: null,
      isSingleLineSelected: false,
      weatherControl: null,
      weatherActive: false,
      currentActivePoiId: null,
      currentSelectedPolyline: null,
      geolocateControl: null,
      firstStartPozition: null,
      lastKnownMarkerPosition: null,
      lastStopDistance: 0,
      staticStopMarker: null,
      elevationData: null,
      lastProgress: 0,
      singlePoiApplied: false,
      streetLineLayer3D: null,
      hnrMarker3D: null,
      startMarker3D: null,
      stopMarker3D: null,
      homeView: null,
      booting: false,
      skipNextAutoFit: false,
      cameraBusy: false,
      userPanning: false,
      suppressAutoFocus: false,
      clickMoveLock: false,
      lastClickAt: 0,
      programmaticSilenceUntil: 0,
      hasResetAfterFlight: false,
      hoverTooltip: {visible: false, x: 0, y: 0, text: ""},
      geolocationMarker: null,
      //nou26.01
      elevationHostEl: null,
      flightHostEl: null,
      currentZoom: 0,

      // data pt layerSF
      projectWmtsConfig: null,
      projectWmtsMatrixByZ: {},
      projectWmtsLayer: null,
      projectWmtsReady: false,

      wmtsConfigLoadId: 0,
      mtkReady: false,

      panoramaHover: {visible: false, x: 0, y: 0, url: null},

      layerSFEnabled: false,
      sfLayerVisible: true
    };
  },
  watch: {
    lat() {
      this.skipNextAutoFit = true;
    },
    lng() {
      this.skipNextAutoFit = true;
    },
    poisGeoJSON: {
      deep: true,
      immediate: true,
      handler(newVal) {
        // if (this.skipNextPoisWatch) {
        //   this.skipNextPoisWatch = false;
        //   return;
        // }
        console.log("[POIS WATCHER RECEIVED]", {
          count: newVal?.features?.length,
          types: newVal?.features?.map(f => f.geometry?.type)
        });
        if (!newVal || !Array.isArray(newVal.features)) {
          this.clearPOIsFromMap(false);
          return;
        }
        const cleanPois = this.normalizeFeatureCollection(newVal);
        if (!cleanPois || !cleanPois.features.length) {
          this.clearPOIsFromMap(false);
          return;
        }
        //modificat 16.07
        // const drawOnly = () => {
        //   this.addPoisOn3DMap(cleanPois);

        //   const first = cleanPois.features?.[0];
        //   const type = first?.geometry?.type;

        //   if (type === "LineString" || type === "MultiLineString") {
        //     this.$nextTick(() => {
        //       this.focusFeatureCollection(cleanPois);
        //     });
        //   }
        // };

        // const drawOnly = () => this.addPoisOn3DMap(cleanPois);
        const drawOnly = () => {
          // desenăm POI-ul / linia
          this.addPoisOn3DMap(cleanPois);

          const feature = cleanPois.features?.[0];
          const type = feature?.geometry?.type;

          console.log("[POIS WATCHER AUTO INIT]", {
            type,
            feature
          });

          if (type !== "LineString" && type !== "MultiLineString") {
            return;
          }

          // creăm polyline tehnic pentru Fly + Elevation
          this.currentSelectedPolyline = this.createTechnicalMtkPolyline(feature);

          console.log("[POIS WATCHER POLYLINE]", this.currentSelectedPolyline);

          if (!this.currentSelectedPolyline) {
            return;
          }

          const width = Number(
            feature.properties?.width ?? feature.properties?.line_width ?? feature.properties?.dbLineWidth ?? 3
          );

          // conectăm linia la FlightControl
          this.setupFlightControl(this.currentSelectedPolyline, width, {moveCamera: false});

          // cerem din nou host-urile din PoiDetails
          this.$root.$emit("mtkReadyForPoi");

          this.$nextTick(() => {
            this.ensureElevationProfile();
            this._mountFlightControlToHost();
          });

          // fallback pentru cazul în care PoiDetails
          // răspunde cu host-urile puțin mai târziu
          setTimeout(() => {
            console.log("[POIS WATCHER FINAL]", {
              polyline: !!this.currentSelectedPolyline,
              flightControl: !!this.flightControl,
              elevationHost: !!this.elevationHostEl,
              flightHost: !!this.flightHostEl
            });

            this.ensureElevationProfile();
            this._mountFlightControlToHost();
          }, 200);
        };
        // const wait = setInterval(() => {
        //   if (this.mtkMap?.gl?.isStyleLoaded?.()) {
        //     clearInterval(wait);
        //     this.$nextTick(drawOnly);
        //   }
        // }, 150);
        const runWhenMapReady = () => {
          const gl = this.mtkMap?.gl;

          if (!gl) {
            setTimeout(runWhenMapReady, 100);
            return;
          }

          console.log("[POIS WATCHER GL READY]", {
            isStyleLoaded: gl.isStyleLoaded?.()
          });

          this.$nextTick(() => {
            requestAnimationFrame(() => {
              drawOnly();
            });
          });
        };

        runWhenMapReady();
      }
    },

    "$i18n.locale"(v) {
      console.log("[i18n.locale changed]", v);
      this._translateDaytimeSoon();
    },
    "$route.query['toc-id']": {
      immediate: true,
      handler(newVal) {
        const has = newVal != null && String(newVal).trim() !== "";
        if (!has) this.clearAllMtkOverlays();
      }
    }
  },

  async mounted() {
    this.loadLayerSFSetting().catch(error => {
      console.error("[SF] Eroare inițializare:", error);
    });
    await this.loadLayerSFSetting();
    window._weatherMTK = this;
    this.$root.weatherActive = true;
    this.$root.$on("triggerGeolocationIn3D", this.triggerGeolocation);
    //nou26.01
    this.$root.$on("mtkElevationHostReady", el => {
      this.elevationHostEl = el;
      this.ensureElevationProfile();
    });

    this.$root.$on("mtkFlightHostReady", el => {
      this.flightHostEl = el;
      this._mountFlightControlToHost();
    });

    this.$root.$on("mtkUiHostsReady", () => {
      this.ensureElevationProfile();
      this._mountFlightControlToHost();
    });

    this._onClusteringChanged = () => {
      if (!this.poisGeoJSON) return;

      const cleanPois = this.normalizeFeatureCollection(this.poisGeoJSON);

      if (!cleanPois || !cleanPois.features.length) {
        this.clearPOIsFromMap(false);
        return;
      }

      this.clearPOIsFromMap(false);
      this.addPoisOn3DMap(cleanPois);
    };

    this.$root.$on("clusteringChanged", this._onClusteringChanged);

    this._onClearAll3D = () => this.clearPOIsFromMap(true);
    this.$root.$on("clearAll3D", this._onClearAll3D);
    this._onClearStreet3D = () => {
      if (this.hnrMarker3D) {
        try {
          this.hnrMarker3D.remove?.();
        } catch (e) {
          console.warn("stop FlightControl:", e);
        }
        this.hnrMarker3D = null;
      }

      if (this.startMarker3D) {
        try {
          this.startMarker3D.remove?.();
        } catch (e) {
          console.warn("stop FlightControl:", e);
        }
        this.startMarker3D = null;
      }
      if (this.stopMarker3D) {
        try {
          this.stopMarker3D.remove?.();
        } catch (e) {
          console.warn("stop FlightControl:", e);
        }
        this.stopMarker3D = null;
      }

      if (this.streetLineLayer3D) {
        try {
          this.streetLineLayer3D.remove?.();
        } catch (e) {
          console.warn("stop FlightControl:", e);
        }
        this.streetLineLayer3D = null;
      }

      if (this.currentSelectedPolyline) {
        try {
          this.currentSelectedPolyline.remove?.();
        } catch (e) {
          console.warn("stop FlightControl:", e);
        }
        this.currentSelectedPolyline = null;
      }
      if (this.flightControl) {
        try {
          this.flightControl.stop?.();
        } catch (e) {
          console.warn("stop FlightControl:", e);
        }
        try {
          this.flightControl.remove?.();
        } catch (e) {
          console.warn("stop FlightControl:", e);
        }
        this.flightControl = null;
      }
      if (this.elevationProfile) {
        try {
          this.elevationProfile.remove?.();
        } catch (e) {
          console.warn("stop FlightControl:", e);
        }
        this.elevationProfile = null;
      }
    };

    this.$root.$on("clearStreet3D", this._onClearStreet3D);

    this.$root.$on("clearFlightPolyline", () => {
      if (this.flightControl) {
        try {
          this.flightControl.stop();
          this.flightControl.remove();
        } catch (e) {
          console.warn("stop FlightControl:", e);
        }
        this.flightControl = null;
      }
      if (this.currentSelectedPolyline) {
        try {
          this.currentSelectedPolyline.remove();
        } catch (e) {
          console.warn("remove polyline:", e);
        }
        this.currentSelectedPolyline = null;
      }
    });

    this.$nextTick(() => {
      const target = this.$refs.map3dweather;
      this.debugPrintInitContext(target, [this.lng, this.lat], this.zoom, {
        preserveDrawingBuffer: true,
        antialias: true
      });
      initMTKMap(target, [this.lng, this.lat], this.zoom, {
        preserveDrawingBuffer: true,
        antialias: true,
        mapType: "toursprung-terrain",

        transformRequest: (url, resourceType) => this._wmtsTransformRequestAll(url, resourceType),

        onReady: map => {
          console.log("[WMTS MTK] onReady primit");

          this.mtkMap = map;
          this.mtkReady = true;

          this.tryMountProjectWmtsLayer();
          this.$nextTick(() => {
            setTimeout(() => {
              this.injectSfIntoStyleControl();
            }, 300);
          });

          map.gl?.once?.("style.load", () => {
            this.tryMountProjectWmtsLayer();
          });

          map.once?.("idle", () => {
            if (!this.projectWmtsLayer) {
              this.tryMountProjectWmtsLayer();
            }
          });
        }
      });

      const waitForMap = setInterval(() => {
        this.mtkMap = getMTKMap();
        if (!this.mtkMap) return;

        clearInterval(waitForMap);
        // const gl = this.mtkMap.gl;

        // gl.setMaxZoom(12.98);

        const gl = this.mtkMap.gl;

        const updateZoomLimit = () => {
          const style = gl.getStyle?.();

          const styleString = JSON.stringify(style || {}).toLowerCase();

          const isSatellite = styleString.includes("satellite");

          if (isSatellite) {
            gl.setMaxZoom(12.89);
            if (gl.getZoom() > 12.89) {
              gl.easeTo({
                zoom: 13,
                duration: 300
              });
            }
          } else {
            // Terrain / Winter
            gl.setMaxZoom(22);
          }

          console.log("[ZOOM LIMIT]", {
            isSatellite,
            maxZoom: isSatellite ? 13 : 22
          });
        };
        updateZoomLimit();

        // verificare când se schimbă Terrain / Winter / Satellite
        gl.on("styledata", updateZoomLimit);
        const restoreDatabaseLayersAfterStyleChange = () => {
          console.log("[MTK STYLE LOAD] restore DB layers");

          const cleanPois = this.normalizeFeatureCollection(this.poisGeoJSON);

          if (!cleanPois || !cleanPois.features?.length) {
            console.log("[MTK STYLE LOAD] no POIs to restore");
            return;
          }

          this.$nextTick(() => {
            requestAnimationFrame(() => {
              console.log(
                "[MTK STYLE LOAD] redraw",
                cleanPois.features.map(f => ({
                  id: f.properties?.id ?? f.id,
                  type: f.geometry?.type
                }))
              );

              this.addPoisOn3DMap(cleanPois);

              const feature = cleanPois.features?.[0];
              const type = feature?.geometry?.type;

              if (type === "LineString" || type === "MultiLineString") {
                this.currentSelectedPolyline = this.createTechnicalMtkPolyline(feature);

                if (this.currentSelectedPolyline) {
                  const width = Number(
                    feature.properties?.width ?? feature.properties?.line_width ?? feature.properties?.dbLineWidth ?? 3
                  );

                  this.setupFlightControl(this.currentSelectedPolyline, width, {moveCamera: false});

                  this.$root.$emit("mtkReadyForPoi");

                  this.$nextTick(() => {
                    this.ensureElevationProfile();
                    this._mountFlightControlToHost();
                  });
                }
              }
            });
          });
        };

        gl.on("style.load", restoreDatabaseLayersAfterStyleChange);

        this.currentZoom = Number(gl.getZoom().toFixed(2));

        gl.on("zoom", () => {
          this.currentZoom = Number(gl.getZoom().toFixed(2));
        });

        gl.on("moveend", () => {
          this.currentZoom = Number(gl.getZoom().toFixed(2));
        });
        this.currentZoom = Number(gl.getZoom().toFixed(2));

        gl.on("zoom", () => {
          this.currentZoom = Number(gl.getZoom().toFixed(2));
        });

        gl.on("moveend", () => {
          this.currentZoom = Number(gl.getZoom().toFixed(2));
        });

        this.debugBindCoreEvents(gl);
        this.debugWrapCamera(gl);

        const isTouchDevice =
          "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

        if (!isTouchDevice) {
          installNoZoomWhileDragging(
            gl,
            () => gl.getZoom(),
            z => gl.jumpTo({zoom: z}),
            gl
          );
        }

        installPanFlags(gl, v => {
          this.userPanning = v;
        });

        const emitViewThrottled = (() => {
          let t = null;
          return (force = false) => {
            if (!force && this._isSilentNow()) return;
            const c = gl.getCenter();
            const z = gl.getZoom();
            const payload = {lat: c.lat, lng: c.lng, lon: c.lng, zoom: z};
            const send = () => {
              this.$emit("updateView", payload);
              this.$root.$emit("mtkViewChanged", payload);
            };
            if (force) {
              send();
              return;
            }
            if (t) return;
            t = setTimeout(() => {
              t = null;
              send();
            }, 150);
          };
        })();

        gl.on("moveend", () => emitViewThrottled(true));

        // layer SF
        const addConfiguredWmtsLayer = () => {
          if (!this.layerSFEnabled || !this.sfLayerVisible) {
            return;
          }
          if (this.projectWmtsReady && this.projectWmtsConfig) {
            this.addProjectWmtsRasterLayer(this.projectWmtsConfig.opacity ?? 1);
          }
        };

        if (gl.isStyleLoaded?.()) {
          addConfiguredWmtsLayer();
        } else {
          gl.once("style.load", addConfiguredWmtsLayer);
        }
        const initAfterMapReady = async () => {
          console.log("[WeatherMTK] initAfterMapReady START");

          gl.resize();

          this.setupFlightControl();

          const handledFromUrl = await this.loadSinglePoiFromUrl();

          let handledFromProp = false;

          if (!handledFromUrl && this.singlePoiFromApi) {
            handledFromProp = await this.applySinglePoiFromApiPayload(this.singlePoiFromApi);
          }

          if (!handledFromUrl && !handledFromProp && this.poisGeoJSON?.features?.length) {
            const fc = this.normalizeFeatureCollection(this.poisGeoJSON);

            if (fc?.features?.length) {
              // this.skipNextPoisWatch = true;
              this.addPoisOn3DMap(fc);
            }
          }

          const fc = this.normalizeFeatureCollection(this.poisGeoJSON);

          const feature = fc?.features?.[0];

          if (feature && (feature.geometry?.type === "LineString" || feature.geometry?.type === "MultiLineString")) {
            console.log("[AUTO LINE INIT]", feature);

            this.currentSelectedPolyline = this.createTechnicalMtkPolyline(feature);

            if (this.currentSelectedPolyline) {
              const width = Number(
                feature.properties?.width ?? feature.properties?.line_width ?? feature.properties?.dbLineWidth ?? 3
              );

              this.setupFlightControl(this.currentSelectedPolyline, width, {moveCamera: false});
            }
          }

          await this.$nextTick();

          console.log("[WeatherMTK] READY -> cer UI de la PoiDetails", {
            polyline: !!this.currentSelectedPolyline,
            flightControl: !!this.flightControl,
            elevationHost: !!this.elevationHostEl,
            flightHost: !!this.flightHostEl
          });

          this.$root.$emit("mtkReadyForPoi");

          setTimeout(() => {
            console.log("[MTK FINAL UI INIT]", {
              polyline: !!this.currentSelectedPolyline,
              flightControl: !!this.flightControl,
              elevationHost: !!this.elevationHostEl,
              flightHost: !!this.flightHostEl
            });

            this.ensureElevationProfile();
            this._mountFlightControlToHost();
          }, 150);

          emitViewThrottled(true);

          this.$emit("weatherMtkMounted");
        };
        if (gl.isStyleLoaded?.()) {
          console.log("[WeatherMTK] style already loaded -> init direct");

          setTimeout(() => {
            initAfterMapReady();
          }, 0);
        } else {
          console.log("[WeatherMTK] waiting style.load");

          gl.once("style.load", () => {
            initAfterMapReady();
          });
        }

        this.$root.$on("poiSelectedFromList", feature => this.handleFeatureFromList(feature));
      }, 100);
    });
  },

  beforeDestroy() {
    this.$root.weatherActive = false;

    // this.$root.$off("startFlightControl", this.onExternalStartFlight);
    // this.$root.$off("stopFlightControl", this.onExternalStopFlight);
    this.$root.$off("triggerGeolocationIn3D", this.triggerGeolocation);
    this.$root.$off("clearAll3D", this._onClearAll3D);
    this.$root.$off("clearStreet3D", this._onClearStreet3D);

    //nou26.01
    this.$root.$off("mtkElevationHostReady");
    this.$root.$off("mtkFlightHostReady");
    this.$root.$off("mtkUiHostsReady");
    this.$root.$off("clusteringChanged", this._onClusteringChanged);

    destroyMTKMap();
  },

  methods: {
    async loadLayerSFSetting() {
      try {
        const projectInfo = Vue.config.project;
        const sf = projectInfo?.sf_basemap;

        console.log("[MTK] SF BASEMAP:", sf);

        this.layerSFEnabled = sf?.layerSF === true;

        if (!this.layerSFEnabled) {
          this.removeProjectWmtsLayer();
          return;
        }

        if (String(sf.type).toLowerCase() !== "wmts") {
          console.warn("[MTK] SF Basemap nu este WMTS:", sf.type);
          return;
        }

        const config = {
          type: "wmts",
          cfgId: sf.id ?? sf.lyid,
          cfgName: sf.name,

          capabilitiesUrl: sf.url,
          layer: sf.lyid,
          serviceUrl: sf.url,
          matrixSet: "GLOBAL_WEBMERCATOR",

          opacity: sf.transparency != null ? 1 - Number(sf.transparency) / 100 : 1
        };

        console.log("[MTK] SF WMTS CONFIG:", config);

        await this.setProjectWmtsConfig(config);
      } catch (error) {
        console.error("[MTK] Eroare încărcare SF:", error);
      }
    },
    moveProjectWmtsBelowWeather() {
      const gl = this.mtkMap?.gl;

      if (!gl) return;

      const style = gl.getStyle?.();

      if (!style?.layers?.length) return;

      const layers = style.layers;
      const sfLayerIds = layers
        .filter(layer => {
          const id = String(layer.id || "").toLowerCase();

          const tiles = JSON.stringify(layer?.source?.tiles || "").toLowerCase();

          return id.includes("project_wmts") || id.includes("wmts") || tiles.includes("dummy.local/project_wmts_proxy");
        })
        .map(layer => layer.id);

      const weatherLayer = layers.find(layer => {
        const id = String(layer.id || "").toLowerCase();

        return (
          id.includes("weather") ||
          id.includes("forecast") ||
          id.includes("temperature") ||
          id.includes("precipitation") ||
          id.includes("cloud")
        );
      });

      console.log("[LAYER ORDER]", {
        sfLayerIds,
        weatherLayer: weatherLayer?.id,
        allLayers: layers.map(l => l.id)
      });

      if (!weatherLayer) {
        console.warn("[SF] Nu am găsit încă layerul weather");
        return;
      }

      sfLayerIds.forEach(layerId => {
        if (!gl.getLayer?.(layerId)) return;

        try {
          // pune SF imediat SUB primul layer weather
          gl.moveLayer(layerId, weatherLayer.id);
        } catch (error) {
          console.warn(`[SF] Nu am putut muta ${layerId} sub weather:`, error);
        }
      });

      gl.triggerRepaint?.();
    },

    injectSfIntoStyleControl() {
      if (!this.layerSFEnabled || !this.projectWmtsConfig) return;

      if (document.querySelector(".mtk-sf-overlay-item")) {
        return;
      }


      const labels = Array.from(document.querySelectorAll(".mtk-control-styles-group-list-item-name"));

      const hikingLabel = labels.find(el => el.textContent?.trim() === "Hiking");

      if (!hikingLabel) {
        console.warn("[SF] Nu am găsit Hiking");
        return;
      }

      // IMPORTANT:
      // luăm întregul <li>, nu parentElement simplu
      const hikingItem = hikingLabel.closest(".mtk-control-styles-group-list-item");

      if (!hikingItem) {
        console.warn("[SF] Nu am găsit tile-ul Hiking");
        return;
      }


      const sfItem = hikingItem.cloneNode(true);

      sfItem.classList.add("mtk-sf-overlay-item");

      sfItem.classList.toggle("mtk-sf-active", this.sfLayerVisible);

      const sfLabel = sfItem.querySelector(".mtk-control-styles-group-list-item-name");

      if (sfLabel) {
        sfLabel.textContent = "Layer SF";
      }

      const sfImage = sfItem.querySelector(".mtk-control-styles-group-list-item-image");

      if (sfImage) {
        sfImage.style.backgroundImage = `url("${sfLayerImage}")`;

        sfImage.style.backgroundSize = "cover";
        sfImage.style.backgroundPosition = "center";
        sfImage.style.backgroundRepeat = "no-repeat";
      }

      const button = sfItem.querySelector("button");

      if (button) {
        button.addEventListener("click", event => {
          event.preventDefault();
          event.stopPropagation();

          this.toggleProjectWmtsLayer();

          sfItem.classList.toggle("mtk-sf-active", this.sfLayerVisible);
          sfItem.classList.add("mtk-sf-overlay-item");
        });
      }

      hikingItem.parentNode.insertBefore(sfItem, hikingItem);

      console.log("[SF] adăugat înainte de Hiking");
    },
    showPanoramaForFeature(feature, point) {
      const url = feature?.properties?.url_360;

      if (!url) {
        this.hidePanoramaHover();
        return;
      }

      this.keepPanoramaHover();

      this.panoramaHover = {
        visible: true,
        x: point.x + 2,
        y: point.y,
        url
      };
    },
    keepPanoramaHover() {
      if (this._panoramaHideTimer) {
        clearTimeout(this._panoramaHideTimer);
        this._panoramaHideTimer = null;
      }
    },

    scheduleHidePanoramaHover() {
      if (this._panoramaHideTimer) {
        clearTimeout(this._panoramaHideTimer);
      }

      this._panoramaHideTimer = setTimeout(() => {
        this.hidePanoramaHover();
      }, 300);
    },
    openHoverPanorama() {
      const url = this.panoramaHover.url;

      if (!url) return;

      window.open(url, "_blank", "noopener,noreferrer");
    },
    setupPanoramaLineHover() {
      const gl = this.mtkMap?.gl;

      if (!gl) return;

      if (this._panoramaMouseMove) {
        gl.off("mousemove", this._panoramaMouseMove);
      }

      this._panoramaMouseMove = e => {
        const pointLayers = [
          "database-pois-single-icon",
          "database-pois-single-fallback",
          "database-pois-icons-never",
          "database-pois-fallback-never"
        ].filter(layerId => gl.getLayer(layerId));

        const lineLayers = ["database-lines-layer"].filter(layerId => gl.getLayer(layerId));

        let feature = null;

        if (pointLayers.length) {
          const pointFeatures = gl.queryRenderedFeatures(e.point, {
            layers: pointLayers
          });

          if (pointFeatures.length) {
            feature = pointFeatures[0];
          }
        }

        if (!feature && lineLayers.length) {
          const lineFeatures = gl.queryRenderedFeatures(e.point, {
            layers: lineLayers
          });

          if (lineFeatures.length) {
            feature = lineFeatures[0];
          }
        }

        if (!feature) {
          this.hidePanoramaHover();
          return;
        }

        const url = feature.properties?.url_360;

        console.log("[PANORAMA ITEM UNDER CURSOR]", {
          id: feature.properties?.id,
          name: feature.properties?.name,
          url_360: feature.properties?.url_360,
          layer: feature.layer?.id
        });
        if (!url) {
          this.hidePanoramaHover();
          return;
        }

        this.showPanoramaForFeature(feature, e.point);

        gl.getCanvas().style.cursor = "pointer";
      };

      gl.on("mousemove", this._panoramaMouseMove);
    },
    hidePanoramaHover() {
      this.panoramaHover.visible = false;
      this.panoramaHover.url = null;

      const gl = this.mtkMap?.gl;

      if (gl) {
        gl.getCanvas().style.cursor = "";
      }
    },
    tryMountProjectWmtsLayer() {
      if (!this.layerSFEnabled || !this.sfLayerVisible) {
        this.removeProjectWmtsLayer();
        return;
      }
      const gl = this.mtkMap?.gl;

      if (!this.mtkMap || !gl) {
        console.log("[WMTS MTK] Harta MTK nu este încă disponibilă");
        return;
      }

      if (!this.projectWmtsReady || !this.projectWmtsConfig) {
        console.log("[WMTS MTK] Configurația WMTS nu este încă pregătită");
        return;
      }
      if (this.projectWmtsLayer) {
        console.log("[SF] Layer deja montat");
        return;
      }

      this.addProjectWmtsRasterLayer(this.projectWmtsConfig.opacity ?? 1);

      this.addProjectWmtsRasterLayer(this.projectWmtsConfig.opacity ?? 1);
    },
    removeProjectWmtsLayer() {
      if (!this.projectWmtsLayer) {
        return;
      }

      try {
        this.projectWmtsLayer.remove?.();
      } catch (error) {
        console.warn("[WMTS MTK] Nu s-a putut elimina layerul:", error);
      }

      this.projectWmtsLayer = null;
    },
    setProjectWmtsVisible(visible) {
      if (!this.layerSFEnabled) {
        this.sfLayerVisible = false;
        this.removeProjectWmtsLayer();
        return;
      }

      this.sfLayerVisible = Boolean(visible);

      if (!this.sfLayerVisible) {
        this.removeProjectWmtsLayer();
        return;
      }

      this.tryMountProjectWmtsLayer();
    },
    toggleProjectWmtsLayer() {
      if (!this.layerSFEnabled || !this.projectWmtsConfig) {
        return;
      }

      this.sfLayerVisible = !this.sfLayerVisible;

      console.log("[SF TOGGLE]", {
        visible: this.sfLayerVisible,
        ready: this.projectWmtsReady,
        mounted: Boolean(this.projectWmtsLayer)
      });

      if (!this.sfLayerVisible) {
        this.removeProjectWmtsLayer();
        return;
      }

      if (this.projectWmtsReady) {
        this.tryMountProjectWmtsLayer();
      }
    },

    getEmptyRasterTile() {
      return (
        "data:image/png;base64," +
        "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwC" +
        "AAAAC0lEQVR42mP8/x8AAwMB/6X9l8kAAAAASUVORK5CYII="
      );
    },
    buildRestWmtsUrl(config, matrixId, col, row) {
      const baseUrl = config.serviceUrl || config.tileServiceUrl;

      if (!baseUrl) {
        console.warn("[WMTS] Lipsește URL-ul GetTile");
        return this.getEmptyRasterTile();
      }

      const url = new URL(baseUrl, window.location.href);

      const params = {
        SERVICE: "WMTS",
        REQUEST: "GetTile",
        VERSION: "1.0.0",
        LAYER: config.layer,
        STYLE: config.style || "default",
        FORMAT: config.format || "image/png",
        TILEMATRIXSET: config.matrixSet,
        TILEMATRIX: matrixId,
        TILEROW: String(row),
        TILECOL: String(col)
      };

      for (const key of Object.keys(params)) {
        for (const existingKey of [...url.searchParams.keys()]) {
          if (existingKey.toUpperCase() === key) {
            url.searchParams.delete(existingKey);
          }
        }

        url.searchParams.set(key, params[key]);
      }

      return url.toString();
    },
    _wmtsTransformRequestAll(url, resourceType) {
      const type = String(resourceType || "").toLowerCase();

      if (type && !["tile", "raster", "image"].includes(type)) {
        return {url};
      }

      if (!url.includes("dummy.local/project_wmts_proxy/")) {
        return {url};
      }

      const match = url.match(/\/project_wmts_proxy\/(\d+)\/(\d+)\/(\d+)\.png(?:\?.*)?$/);

      if (!match) {
        return {url};
      }

      const zoom = Number(match[1]);
      const globalCol = Number(match[2]);
      const globalRow = Number(match[3]);

      const tileUrl = this.buildProjectWmtsTileUrl(zoom, globalCol, globalRow);

      return {
        url: tileUrl
      };
    },
    buildProjectWmtsTileUrl(zoom, globalCol, globalRow) {
      const config = this.projectWmtsConfig;
      const matrix = this.projectWmtsMatrixByZ?.[zoom];

      if (!config || !matrix) {
        return this.getEmptyRasterTile();
      }

      const localPosition = this.mapGlobalTileToWmts(matrix, globalCol, globalRow);

      if (!localPosition) {
        return this.getEmptyRasterTile();
      }

      const {col, row} = localPosition;

      if (config.resourceTemplate) {
        return config.resourceTemplate
          .replace(/\{TileMatrixSet\}/gi, config.matrixSet)
          .replace(/\{TileMatrix\}/gi, matrix.id)
          .replace(/\{TileCol\}/gi, String(col))
          .replace(/\{TileRow\}/gi, String(row))
          .replace(/\{Style\}/gi, config.style || "default");
      }

      return this.buildRestWmtsUrl(config, matrix.id, col, row);
    },
    mapGlobalTileToWmts(matrix, globalCol, globalRow) {
      const globalOriginX = -20037508.342789244;
      const globalOriginY = 20037508.342789244;

      const tileSpanX = matrix.res * matrix.tileW;
      const tileSpanY = matrix.res * matrix.tileH;

      const rawXOffset = (matrix.TL_X - globalOriginX) / tileSpanX;

      const rawYOffset = (globalOriginY - matrix.TL_Y) / tileSpanY;

      const xOffset = Math.round(rawXOffset);
      const yOffset = Math.round(rawYOffset);

      const col = globalCol - xOffset;
      const row = globalRow - yOffset;

      if (col < 0 || row < 0) {
        return null;
      }

      if (Number.isFinite(matrix.matrixWidth) && col >= matrix.matrixWidth) {
        return null;
      }

      if (Number.isFinite(matrix.matrixHeight) && row >= matrix.matrixHeight) {
        return null;
      }

      return {col, row};
    },
    async setProjectWmtsConfig(config) {
      if (!this.layerSFEnabled) {
        return;
      }
      if (!config?.capabilitiesUrl) {
        console.warn("[WMTS] Lipsește capabilitiesUrl");
        return;
      }

      const sameConfig =
        this.projectWmtsConfig?.cfgId === config.cfgId &&
        this.projectWmtsConfig?.capabilitiesUrl === config.capabilitiesUrl &&
        this.projectWmtsConfig?.layer === config.layer &&
        this.projectWmtsConfig?.matrixSet === config.matrixSet;

      if (sameConfig && this.projectWmtsReady) {
        return;
      }

      this.projectWmtsConfig = {
        ...config
      };

      this.projectWmtsReady = false;

      try {
        await this.loadProjectWmtsCapabilities();

        this.projectWmtsReady = true;

        if (this.mtkMap?.gl?.isStyleLoaded?.()) {
          this.addProjectWmtsRasterLayer();
        }
      } catch (error) {
        console.error("[WMTS] Eroare la încărcarea configurației proiectului:", error);
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.injectSfIntoStyleControl?.();
        }, 200);
      });
    },
    async loadProjectWmtsCapabilities() {
      const config = this.projectWmtsConfig;

      if (!config?.capabilitiesUrl) {
        throw new Error("WMTS capabilities URL lipsește");
      }

      const response = await fetch(config.capabilitiesUrl, {
        cache: "force-cache"
      });

      if (!response.ok) {
        throw new Error(`WMTS capabilities HTTP ${response.status}: ` + config.capabilitiesUrl);
      }

      const xmlText = await response.text();

      const documentXml = new DOMParser().parseFromString(xmlText, "text/xml");

      if (documentXml.querySelector("parsererror")) {
        throw new Error("WMTS capabilities XML invalid");
      }

      const layerInfo = this.parseWmtsLayerInfo(documentXml, config.layer);

      const matrixInfo = this.parseWmtsMatrixSet(documentXml, config.matrixSet);

      this.projectWmtsConfig = {
        ...config,
        ...layerInfo
      };

      this.projectWmtsMatrixByZ = matrixInfo;

      console.log("[WMTS MTK] Configurație încărcată:", {
        layer: this.projectWmtsConfig.layer,
        matrixSet: this.projectWmtsConfig.matrixSet,
        resourceTemplate: this.projectWmtsConfig.resourceTemplate,
        zooms: Object.keys(matrixInfo)
      });
    },
    parseWmtsLayerInfo(xml, requestedLayerId) {
      const getIdentifier = node => [...node.getElementsByTagNameNS("*", "Identifier")][0]?.textContent?.trim();

      const layers = [...xml.getElementsByTagNameNS("*", "Layer")];

      const selectedLayer = layers.find(layer => getIdentifier(layer) === requestedLayerId);

      if (!selectedLayer) {
        const availableLayers = layers.map(getIdentifier).filter(Boolean);

        throw new Error(`WMTS Layer "${requestedLayerId}" nu există. ` + `Disponibile: ${availableLayers.join(", ")}`);
      }

      if (!selectedLayer) {
        throw new Error("Capabilities nu conține niciun WMTS Layer");
      }

      const layerId = getIdentifier(selectedLayer);

      const resourceUrls = [...selectedLayer.getElementsByTagNameNS("*", "ResourceURL")];

      const tileResource = resourceUrls.find(node => node.getAttribute("resourceType") === "tile");

      const resourceTemplate = tileResource?.getAttribute("template") || null;

      const format =
        tileResource?.getAttribute("format") ||
        [...selectedLayer.getElementsByTagNameNS("*", "Format")][0]?.textContent?.trim() ||
        "image/png";

      return {
        layer: layerId,
        resourceTemplate,
        format
      };
    },
    parseWmtsMatrixSet(xml, requestedMatrixSetId) {
      const getFirstText = (node, tagName) =>
        [...node.getElementsByTagNameNS("*", tagName)][0]?.textContent?.trim() || null;

      const matrixSets = [...xml.getElementsByTagNameNS("*", "TileMatrixSet")];

      const selectedSet = matrixSets.find(set => getFirstText(set, "Identifier") === requestedMatrixSetId);

      if (!selectedSet) {
        const available = matrixSets.map(set => getFirstText(set, "Identifier")).filter(Boolean);

        throw new Error(`TileMatrixSet "${requestedMatrixSetId}" nu există. ` + `Disponibile: ${available.join(", ")}`);
      }

      const matrices = [...selectedSet.getElementsByTagNameNS("*", "TileMatrix")];

      const byGlobalZoom = {};

      const globalResolution0 = 156543.03392804097;

      for (const matrix of matrices) {
        const id = getFirstText(matrix, "Identifier");
        const scaleDenominator = Number(getFirstText(matrix, "ScaleDenominator"));

        const topLeftCornerText = getFirstText(matrix, "TopLeftCorner");

        if (!id || !Number.isFinite(scaleDenominator) || !topLeftCornerText) {
          continue;
        }

        const [topLeftX, topLeftY] = topLeftCornerText.split(/\s+/).map(Number);

        const resolution = scaleDenominator * 0.00028;

        const globalZoom = Math.round(Math.log2(globalResolution0 / resolution));

        const expectedResolution = globalResolution0 / Math.pow(2, globalZoom);

        const relativeError = Math.abs(resolution - expectedResolution) / expectedResolution;

        if (relativeError > 0.05) {
          console.warn(`[WMTS] Matrix ${id} nu corespunde exact unui zoom global`, {
            resolution,
            globalZoom,
            relativeError
          });
        }

        byGlobalZoom[globalZoom] = {
          id,
          res: resolution,
          TL_X: topLeftX,
          TL_Y: topLeftY,
          tileW: Number(getFirstText(matrix, "TileWidth")) || 256,
          tileH: Number(getFirstText(matrix, "TileHeight")) || 256,
          matrixWidth: Number(getFirstText(matrix, "MatrixWidth")) || undefined,
          matrixHeight: Number(getFirstText(matrix, "MatrixHeight")) || undefined
        };
      }

      if (!Object.keys(byGlobalZoom).length) {
        throw new Error(`Nu s-a putut citi nicio TileMatrix din ${requestedMatrixSetId}`);
      }

      return byGlobalZoom;
    },
    addProjectWmtsRasterLayer(opacity = 1) {
      if (!this.layerSFEnabled || !this.sfLayerVisible) {
        return;
      }
      if (!this.mtkMap || !this.projectWmtsReady || !this.projectWmtsConfig) {
        return;
      }

      this.removeProjectWmtsLayer();

      const MTK = window.MTK;

      if (!MTK?.RasterLayer) {
        console.error("[WMTS MTK] MTK.RasterLayer nu este disponibil");
        return;
      }

      const dummyUrl = "https://dummy.local/project_wmts_proxy/{z}/{x}/{y}.png";

      try {
        this.projectWmtsLayer = new MTK.RasterLayer({
          tiles: [dummyUrl],
          tileSize: 256,
          minzoom: 0,
          maxzoom: 22,
          opacity: Number(opacity),
          attribution: this.projectWmtsConfig.attribution || "© map2web"
        });

        this.projectWmtsLayer.addTo(this.mtkMap);

        this.$nextTick(() => {
          this.moveProjectWmtsBelowWeather();
        });

        setTimeout(() => {
          this.moveProjectWmtsBelowWeather();
        }, 500);
      } catch (error) {
        this.projectWmtsLayer = null;
        console.error("[WMTS MTK] Eroare la adăugarea RasterLayer:", error);
      }
    },

    moveProjectWmtsLayerToTop() {
      const gl = this.mtkMap?.gl;

      if (!gl || !this.projectWmtsLayer) {
        return;
      }

      let movedWithMtkApi = false;

      try {
        if (typeof this.projectWmtsLayer.bringToFront === "function") {
          this.projectWmtsLayer.bringToFront();
          movedWithMtkApi = true;
        } else if (typeof this.projectWmtsLayer.setZIndex === "function") {
          this.projectWmtsLayer.setZIndex(9999);
          movedWithMtkApi = true;
        }
      } catch (error) {
        console.warn("[WMTS MTK] Mutarea WMTS prin API MTK a eșuat:", error);
      }

      if (!movedWithMtkApi) {
        const style = gl.getStyle?.();
        const layers = style?.layers || [];
        const sources = style?.sources || {};

        const sfLayerIds = layers
          .filter(layer => {
            const id = String(layer.id || "").toLowerCase();

            const source = layer.source ? sources[layer.source] : null;

            const tiles = Array.isArray(source?.tiles) ? source.tiles.join(" ") : "";

            return id.includes("project_wmts") || tiles.includes("dummy.local/project_wmts_proxy");
          })
          .map(layer => layer.id);

        sfLayerIds.forEach(layerId => {
          if (!gl.getLayer(layerId)) {
            return;
          }

          try {
            gl.moveLayer(layerId);
          } catch (error) {
            console.warn(`[WMTS MTK] Nu s-a putut muta ${layerId}:`, error);
          }
        });
      }

      // După SF, readucem elementele DB în față.
      this.moveDatabaseLayersAboveWmts();
    },
    moveDatabaseLayersAboveWmts() {
      const gl = this.mtkMap?.gl;

      if (!gl) {
        return;
      }

      const layerIds = [
        // Poligoane
        "database-polygons-fill",
        "database-polygons-outline",

        // Linii
        "database-lines-layer",

        // POI fără cluster
        "database-pois-fallback-never",
        "database-pois-icons-never",

        // Clustere
        "database-pois-clusters",
        "database-pois-cluster-count",

        // POI individual din cluster
        "database-pois-single-fallback",
        "database-pois-single-icon"
      ];

      layerIds.forEach(layerId => {
        if (!gl.getLayer?.(layerId)) {
          return;
        }

        try {
          gl.moveLayer(layerId);
        } catch (error) {
          console.warn(`[DB MTK] Nu s-a putut muta ${layerId}:`, error);
        }
      });

      gl.triggerRepaint?.();
    },

    resetToHome({lat, lng, zoom}) {
      const gl = this.mtkMap?.gl;
      if (!gl) {
        console.warn("[WeatherMTK] resetToHome: mtkMap.gl lipsește");
        return;
      }

      this._markProgrammatic?.(1000);

      try {
        this.clearAllMtkOverlays?.();
        this.clearPOIsFromMap?.();

        this.currentActivePoiId = null;
        this.currentSelectedPolyline = null;
        this.singlePoiApplied = false;
        this.skipNextAutoFit = true;
        this.cameraBusy = false;
        this.userPanning = false;
        this.suppressAutoFocus = false;
        this.clickMoveLock = false;
        this.hasResetAfterFlight = false;

        gl.flyTo({
          center: [lng, lat],
          zoom,
          pitch: 0,
          bearing: 0,
          speed: 1.2,
          curve: 1,
          essential: true
        });

        this.$emit("updateView", {lat, lng, lon: lng, zoom});
      } catch (e) {
        console.warn("[WeatherMTK] resetToHome failed:", e);
      }
    },
    clearAllMtkOverlays() {
      this.clearPOIsFromMap();
      this._hideHoverTooltip?.();

      if (this.flightControl) {
        try {
          this.flightControl.stop?.();
        } catch (e) {
          console.warn("[WeatherMTK] flightControl.stop failed:", e);
        }
        try {
          this.flightControl.remove?.();
        } catch (e) {
          console.warn("[WeatherMTK] flightControl.remove failed:", e);
        }
        this.flightControl = null;
      }

      if (this.elevationProfile) {
        try {
          this.elevationProfile.remove?.();
        } catch (e) {
          console.warn("[WeatherMTK] elevation failed:", e);
        }
        this.elevationProfile = null;
      }

      if (this.geolocationMarker) {
        try {
          this.geolocationMarker.remove?.();
        } catch (e) {
          console.warn("[WeatherMTK] geolocation failed:", e);
        }
        this.geolocationMarker = null;
      }

      if (this.elevationHostEl) this.elevationHostEl.innerHTML = "";
      if (this.flightHostEl) this.flightHostEl.innerHTML = "";
    },
    _translateDaytimeSoon() {
      clearTimeout(this._daytimeT);
      this._daytimeT = setTimeout(() => {
        this.translateDaytimeControl();
      }, 50);
    },

    translateDaytimeControl() {
      const locale = this.$i18n.locale || "en";
      const t = DAYTIME_I18N[locale] || DAYTIME_I18N.en;

      const buttons = document.querySelectorAll(".mtk-daytime-control-button");

      const isToday = txt => ["Today", "Astăzi", "Heute"].includes(txt);
      const isTomorrow = txt => ["Tomorrow", "Mâine", "Morgen"].includes(txt);

      const monthIndex = {};
      Object.values(DAYTIME_I18N).forEach(lang => {
        lang.months.forEach((m, i) => {
          monthIndex[m.toLowerCase()] = i;
        });
      });

      buttons.forEach(btn => {
        const txt = btn.innerText.trim();

        // Today / Tomorrow
        if (isToday(txt)) {
          btn.innerText = t.today;
          return;
        }

        if (isTomorrow(txt)) {
          btn.innerText = t.tomorrow;
          return;
        }
        const m = txt.match(/^(\d{1,2})\s+(.+)$/);
        if (!m) return;

        const day = m[1];
        const monthName = m[2].toLowerCase();

        const mi = monthIndex[monthName];

        if (mi != null) {
          btn.innerText = `${day} ${t.months[mi]}`;
        }
      });
    },

    //mou26.01
    _mountFlightControlToHost() {
      if (!this.flightControl || !this.flightControl._container) return;
      if (!this.flightHostEl) return;

      this.flightHostEl.innerHTML = "";
      this.flightHostEl.appendChild(this.flightControl._container);

      this.$root.$emit("mtkFlightControlReady", this.flightControl._container);
    },
    resetCameraTo2DNorth() {
      const gl = this.mtkMap?.gl;
      if (!gl) return;

      try {
        gl.easeTo({
          pitch: 0,
          bearing: 0,
          duration: 600
        });
      } catch (e) {
        console.warn("[WeatherMTK] resetCameraTo2DNorth failed:", e);
      }
    },

    focusFeatureCollectionInitial(fc, opts = {}) {
      const safe = this.normalizeFeatureCollection(fc);
      if (!safe || !safe.features?.length) return;
      const boundsAll = new window.maplibregl.LngLatBounds();
      const allCoords = [];
      safe.features.forEach(f => {
        const g = f.geometry;
        if (!g) return;
        const push = c => {
          boundsAll.extend(c);
          allCoords.push(c);
        };

        if (g.type === "Point") push(g.coordinates);
        else if (g.type === "LineString") g.coordinates.forEach(push);
        else if (g.type === "MultiLineString") g.coordinates.flat().forEach(push);
        else if (g.type === "Polygon") g.coordinates[0].forEach(push);
        else if (g.type === "MultiPolygon") g.coordinates.flat(2).forEach(push);
      });

      const ctx = {
        ok: true,
        featuresCount: safe.features.length,
        firstFeature: safe.features[0],
        allCoords,
        boundsAll: boundsAll.isEmpty() ? null : boundsAll
      };

      this.focusMapAfterAdding(ctx, {
        paddingMulti: this.getFitPadding(),
        durationMulti: 900,
        paddingSingle: this.getFitPadding(),
        durationSingle: 1200,
        ...opts
      });
    },
    focusFeatureCollection(fc, opts = {}) {
      const safe = this.normalizeFeatureCollection(fc);
      if (!safe || !safe.features?.length) return;

      const boundsAll = new window.maplibregl.LngLatBounds();
      const allCoords = [];

      safe.features.forEach(f => {
        const g = f.geometry;
        if (!g) return;

        const push = c => {
          boundsAll.extend(c);
          allCoords.push(c);
        };

        if (g.type === "Point") push(g.coordinates);
        else if (g.type === "LineString") g.coordinates.forEach(push);
        else if (g.type === "MultiLineString") g.coordinates.flat().forEach(push);
        else if (g.type === "Polygon") g.coordinates[0].forEach(push);
        else if (g.type === "MultiPolygon") g.coordinates.flat(2).forEach(push);
      });

      const ctx = {
        ok: true,
        featuresCount: safe.features.length,
        firstFeature: safe.features[0],
        allCoords,
        boundsAll: boundsAll.isEmpty() ? null : boundsAll
      };

      const geomType = safe.features[0]?.geometry?.type || null;

      this.focusMapAfterAdding(ctx, {
        paddingMulti: this.getFitPadding(geomType),
        durationMulti: 900,
        paddingSingle: this.getFitPadding(geomType),
        durationSingle: 1200,
        ...opts
      });
    },

    focusFeatureOnly(feature) {
      this.focusFeatureOnce(feature);
    },
    _markProgrammatic(ms = 900) {
      this.programmaticSilenceUntil = performance.now() + ms;
    },
    _isSilentNow() {
      return performance.now() < this.programmaticSilenceUntil;
    },
    onOLViewChanged({lat, lng, zoom, instant = true} = {}) {
      const gl = this.mtkMap?.gl;
      if (!gl || typeof lat !== "number" || typeof lng !== "number") return;
      this._markProgrammatic(900);
      try {
        if (instant) {
          gl.jumpTo({center: [lng, lat], zoom: typeof zoom === "number" ? zoom : gl.getZoom()});
        } else {
          gl.easeTo({center: [lng, lat], zoom: typeof zoom === "number" ? zoom : gl.getZoom(), duration: 600});
        }
      } catch (e) {
        console.warn("onOLViewChanged failed:", e);
      }
    },
    _getBestLineCoordsFromFeatures(features) {
      const lines = [];

      const hav = (a, b) => {
        const toRad = d => (d * Math.PI) / 180,
          R = 6371000;
        const dLat = toRad(b[1] - a[1]),
          dLng = toRad(b[0] - a[0]);
        const s1 = Math.sin(dLat / 2),
          s2 = Math.sin(dLng / 2);
        const aa = s1 * s1 + Math.cos(toRad(a[1])) * Math.cos(toRad(b[1])) * s2 * s2;
        return 2 * R * Math.asin(Math.min(1, Math.sqrt(aa)));
      };
      const lengthOf = coords => {
        let L = 0;
        for (let i = 1; i < coords.length; i++) L += hav(coords[i - 1], coords[i]);
        return L;
      };

      for (const f of features) {
        const g = f?.geometry;
        if (!g) continue;
        if (g.type === "LineString" && g.coordinates?.length >= 2) {
          lines.push(g.coordinates);
        }
        if (g.type === "MultiLineString" && Array.isArray(g.coordinates)) {
          g.coordinates.forEach(seg => {
            if (seg?.length >= 2) lines.push(seg);
          });
        }
      }

      if (!lines.length) return null;
      let best = lines[0],
        bestL = lengthOf(best);
      for (let i = 1; i < lines.length; i++) {
        const L = lengthOf(lines[i]);
        if (L > bestL) {
          best = lines[i];
          bestL = L;
        }
      }
      return best;
    },
    async focusFeatureOnce(feature) {
      if (this.clickMoveLock) return;

      const now = performance.now();
      if (now - this.lastClickAt < 300) return;
      this.lastClickAt = now;

      const gl = this.mtkMap?.gl;
      const g = feature?.geometry;
      if (!gl || !g) return;

      this.clickMoveLock = true;
      this._markProgrammatic(900);

      const end = () =>
        setTimeout(() => {
          this.clickMoveLock = false;
        }, 0);
      const epsDeg = 1e-5; // ~1 m

      try {
        if (g.type === "Point") {
          const [lng, lat] = g.coordinates;
          const cur = gl.getCenter(),
            cz = gl.getZoom();
          const sameCenter = Math.abs(cur.lng - lng) < epsDeg && Math.abs(cur.lat - lat) < epsDeg;
          if (sameCenter) {
            end();
            return;
          }

          gl.flyTo({
            center: [lng, lat],
            zoom: cz,
            speed: 4,
            curve: 1.05
          });
        } else {
          const b = new window.maplibregl.LngLatBounds();
          const ext = c => b.extend(c);

          if (g.type === "LineString") g.coordinates.forEach(ext);
          if (g.type === "MultiLineString") g.coordinates.flat().forEach(ext);
          if (g.type === "Polygon") g.coordinates.forEach(r => r.forEach(ext));
          if (g.type === "MultiPolygon") g.coordinates.forEach(p => p.forEach(r => r.forEach(ext)));

          if (b.isEmpty()) {
            end();
            return;
          }

          gl.fitBounds(b, {
            // padding: 100,
            padding: this.getFitPadding(g.type),
            duration: 1200,
            linear: false,
            easing: t => 1 - Math.pow(1 - t, 2)
          });
        }
        await this.$nextTick();
        console.log("ON POI FROM 3D WIDTH:", feature.properties?.width);
        this.$emit("poi-click", {
          id: feature?.properties?.id ?? feature?.id,
          name: feature?.properties?.name,
          parent: {id: feature?.properties?.parent_id ?? feature?.properties?.parent?.id},
          geom: feature?.geometry,
          properties: feature?.properties,
          style: feature?.properties?.style,
          width: feature?.properties?.width,
          short_info: feature?.properties?.short_info,
          url_360: feature?.properties?.url_360
        });

        gl.once?.("moveend", () =>
          setTimeout(() => {
            this.clickMoveLock = false;
          }, 50)
        );
      } catch (e) {
        console.warn("focusFeatureOnce error:", e);
        end();
      }
    },

    debugPrintInitContext(targetEl, initCenter, initZoom, initOpts) {
      if (!DBG.init) return;
      try {
        const br = targetEl?.getBoundingClientRect?.() || {};
        const ctx = {
          componentProps: {lat: this.lat, lng: this.lng, zoom: this.zoom},
          homeCenterProp: this.homeCenter,
          route: {path: this.$route?.path, query: this.$route?.query},
          containerPx: {w: Math.round(br.width || 0), h: Math.round(br.height || 0)},
          dpr: window.devicePixelRatio || 1,
          initArgs: {center: initCenter, zoom: initZoom, opts: initOpts},
          time: new Date().toISOString()
        };
        console.groupCollapsed("%c[WeatherMTK] ▶ MTK INIT CONTEXT", "color:#08f");
        console.table(ctx);
        console.groupEnd();
      } catch (e) {
        console.warn("[WeatherMTK] debugPrintInitContext fail", e);
      }
    },

    debugWrapCamera(gl) {
      if (!DBG.camera || !gl) return;
      const wrap = (name, fn) => (...args) => {
        const before = {
          center: gl.getCenter && gl.getCenter(),
          zoom: gl.getZoom && gl.getZoom(),
          pitch: gl.getPitch && gl.getPitch(),
          bearing: gl.getBearing && gl.getBearing()
        };
        console.groupCollapsed(`%c[MTK.Camera] ${name}`, "color:#f60");
        console.log("args:", args);
        console.log("before:", before);
        console.trace("stack");
        try {
          const ret = fn.apply(gl, args);
          // after next frame,
          setTimeout(() => {
            const after = {
              center: gl.getCenter && gl.getCenter(),
              zoom: gl.getZoom && gl.getZoom(),
              pitch: gl.getPitch && gl.getPitch(),
              bearing: gl.getBearing && gl.getBearing()
            };
            console.log("after:", after);
            console.groupEnd();
          }, 0);
          return ret;
        } catch (e) {
          console.error(`[MTK.Camera] ${name} error`, e);
          console.groupEnd();
          throw e;
        }
      };

      const camFns = ["flyTo", "fitBounds", "jumpTo", "easeTo", "setCenter", "setZoom", "panTo"];
      camFns.forEach(n => {
        if (typeof gl[n] === "function" && !gl[`__wrapped_${n}`]) {
          gl[`__orig_${n}`] = gl[n];
          gl[n] = wrap(n, gl[n]);
          gl[`__wrapped_${n}`] = true;
        }
      });
    },
    debugBindCoreEvents(gl) {
      if (!DBG.events || !gl?.on) return;
      const pr = (e, extra = {}) => {
        const c = gl.getCenter ? gl.getCenter() : null;
        const payload = {
          zoom: gl.getZoom?.(),
          lat: c?.lat,
          lng: c?.lng,
          pitch: gl.getPitch?.(),
          bearing: gl.getBearing?.(),
          ...extra
        };
        console.log(`[MTK ${e}]`, payload);
      };

      gl.on("load", () => pr("load"));
      gl.on("style.load", () => pr("style.load"));
      gl.on("idle", () => pr("idle"));
      gl.on("movestart", () => pr("movestart"));
      gl.on("move", () => {
        /* zgomotos, lasă-l comentat dacă e prea mult */
      });
      gl.on("moveend", () => pr("moveend"));
      gl.on("zoomstart", () => pr("zoomstart"));
      gl.on("zoomend", () => pr("zoomend"));
      gl.on("pitchstart", () => pr("pitchstart"));
      gl.on("pitchend", () => pr("pitchend"));
      gl.on("rotatestart", () => pr("rotatestart"));
      gl.on("rotateend", () => pr("rotateend"));
      gl.on("resize", () => pr("resize", {size: gl.getContainer?.().getBoundingClientRect?.()}));
      gl.on("error", e => console.warn("[MTK error]", e?.error || e));
    },
    debugAfterMapReady(mtkMap, t0) {
      try {
        const gl = mtkMap?.gl;
        const dur = Math.round(performance.now() - t0);
        const center = gl?.getCenter?.();
        const payload = {
          timeToIdleMs: dur,
          centerLng: center?.lng,
          centerLat: center?.lat,
          zoom: gl?.getZoom?.(),
          bearing: gl?.getBearing?.(),
          pitch: gl?.getPitch?.(),
          containerPx: gl?.getContainer?.()?.getBoundingClientRect?.(),
          dpr: window.devicePixelRatio || 1,
          styleLoaded: gl?.isStyleLoaded?.()
        };
        console.groupCollapsed("%c[WeatherMTK] ✓ Map READY", "color:#0a0");
        console.table(payload);
        console.groupEnd();
      } catch (e) {
        console.warn("[WeatherMTK] debugAfterMapReady fail", e);
      }
    },
    async snapshot3DForPrint({pxWidth, pxHeight}) {
      const map = this.mtkMap?.gl;
      if (!map?.getCanvas) throw new Error("3D map not ready");

      const container = map.getContainer();
      const canvas = map.getCanvas();

      const dpr = window.devicePixelRatio || 1;
      const cssW = Math.round(pxWidth / dpr);
      const cssH = Math.round(pxHeight / dpr);

      const oldW = container.style.width;
      const oldH = container.style.height;

      container.style.width = cssW + "px";
      container.style.height = cssH + "px";
      map.resize();

      await new Promise(res => {
        const done = () => res();
        map.once("idle", done);
        map.triggerRepaint?.();
        // requestAnimationFrame(() => {});
      });

      let dataUrl;
      try {
        dataUrl = canvas.toDataURL("image/png");
      } catch (e) {
        console.error("toDataURL failed (tainted?)", e);
        const off = document.createElement("canvas");
        off.width = canvas.width;
        off.height = canvas.height;
        off.getContext("2d").drawImage(canvas, 0, 0);
        dataUrl = off.toDataURL("image/png");
      }

      container.style.width = oldW || "";
      container.style.height = oldH || "";
      map.resize();

      return dataUrl;
    },
    getFitPaddingInitial() {
      const padding = {top: 150, right: 30, bottom: 80, left: 30};
      console.log("[WeatherMTK] getFitPadding ->", padding);
      return padding;
    },
    getFitPadding(geometryType = null) {
      const isMobile = window.innerWidth <= 768;

      if (isMobile) {
        // pentru geometrii care trebuie coborâte pe ecran
        if (
          geometryType === "LineString" ||
          geometryType === "MultiLineString" ||
          geometryType === "Polygon" ||
          geometryType === "MultiPolygon"
        ) {
          return {
            top: 300, // mare => mută geometria mai jos
            right: 40,
            bottom: 40,
            left: 40
          };
        }

        // fallback mobil
        return {
          top: 320,
          right: 40,
          bottom: 80,
          left: 40
        };
      }

      // desktop
      return {
        top: 150,
        right: 30,
        bottom: 80,
        left: 30
      };
    },
    fitBoundsWithPadding(bounds, extraOpts = {}) {
      if (!this.mtkMap?.gl?.fitBounds) {
        console.warn("[WeatherMTK] fitBoundsWithPadding: gl.fitBounds indisponibil");
        return;
      }
      const padding = this.getFitPadding();
      const opts = {padding, duration: 1200, ...extraOpts};
      this.mtkMap.gl.fitBounds(bounds, opts);
    },
    computeFeatureCenter(geometry) {
      if (!geometry) return null;
      if (geometry.type === "Point") return geometry.coordinates;

      const b = new window.maplibregl.LngLatBounds();
      const push = c => b.extend(c);

      if (geometry.type === "LineString") geometry.coordinates.forEach(push);
      if (geometry.type === "MultiLineString") geometry.coordinates.flat().forEach(push);
      if (geometry.type === "Polygon") geometry.coordinates[0].forEach(push);
      if (geometry.type === "MultiPolygon") geometry.coordinates.flat(2).forEach(push);

      if (!b.isEmpty()) {
        const c = b.getCenter();
        return [c.lng, c.lat];
      }
      return null;
    },
    _quantize(n, dec = 4) {
      const p = Math.pow(10, dec);
      return Math.round(n * p) / p;
    },
    svgCircleDataUrl(color = "#00ff00", stroke = "black", r = 15) {
      const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
        <circle cx="50" cy="50" r="${r}" fill="${color}" stroke="${stroke}" stroke-width="5"/>
      </svg>`;
      return "data:image/svg+xml;base64," + btoa(svg);
    },
    handleFeatureFromList(feature) {
      const role = feature?.properties?.role;
      const type = feature?.geometry?.type;

      if (role === "street" && (type === "LineString" || type === "MultiLineString")) {
        this.addOrUpdateStreet(feature);
        return;
      }
      if (role === "hnr" && type === "Point") {
        this.addOrUpdateHnrMarker(feature);
        return;
      }
      this.focusOnPoi(feature);
    },
    addOrUpdateStreet(feature) {
      const safe = this.normalizeFeatureCollection(feature);
      if (!safe || !safe.features.length) return;
      feature = safe.features[0];

      const geom = feature.geometry;
      if (!geom || !Array.isArray(geom.coordinates)) return;
      if (this.streetLineLayer3D) {
        this.streetLineLayer3D.remove();
        this.streetLineLayer3D = null;
      }

      const color = feature.properties?.line_color || "#ff0000";
      const width = feature.properties?.width || 4;

      const polylines = [];
      const bounds = new window.maplibregl.LngLatBounds();

      const eachSegment = geom.type === "LineString" ? [geom.coordinates] : geom.coordinates;

      eachSegment.forEach(seg => {
        if (!Array.isArray(seg) || seg.length < 2) return;
        const pl = new MTK.Polyline({color, width});
        pl.setLngLats(seg);
        seg.forEach(c => bounds.extend(c));
        polylines.push(pl);
      });

      if (!polylines.length) return;

      this.streetLineLayer3D = new MTK.CollectionLayer(MTK.Polyline);
      this.streetLineLayer3D.setLayers(polylines);
      this.streetLineLayer3D.addTo(this.mtkMap);

      const keyOf = ([lng, lat]) => {
        const r = v => Math.round(v * 1e5) / 1e5; // ~1m snap
        return `${r(lng)},${r(lat)}`;
      };
      const haversine = (a, b) => {
        const toRad = d => (d * Math.PI) / 180;
        const R = 6371000;
        const dLat = toRad(b[1] - a[1]);
        const dLng = toRad(b[0] - a[0]);
        const s1 = Math.sin(dLat / 2),
          s2 = Math.sin(dLng / 2);
        const aa = s1 * s1 + Math.cos(toRad(a[1])) * Math.cos(toRad(b[1])) * s2 * s2;
        return 2 * R * Math.asin(Math.min(1, Math.sqrt(aa)));
      };

      const segments = eachSegment;
      const degree = new Map();
      const endpointsArray = [];

      segments.forEach(seg => {
        if (!Array.isArray(seg) || seg.length < 2) return;
        const a = seg[0],
          b = seg[seg.length - 1];
        const ka = keyOf(a),
          kb = keyOf(b);
        degree.set(ka, (degree.get(ka) || 0) + 1);
        degree.set(kb, (degree.get(kb) || 0) + 1);
        endpointsArray.push(a, b);
      });

      const leaves = endpointsArray.filter(p => (degree.get(keyOf(p)) || 0) % 2 === 1);
      const candidates = leaves.length >= 2 ? leaves : endpointsArray;

      let bestA = candidates[0],
        bestB = candidates[0],
        bestD = -1;
      for (let i = 0; i < candidates.length; i++) {
        for (let j = i + 1; j < candidates.length; j++) {
          const d = haversine(candidates[i], candidates[j]);
          if (d > bestD) {
            bestD = d;
            bestA = candidates[i];
            bestB = candidates[j];
          }
        }
      }
      if (this.startMarker3D) {
        this.startMarker3D.remove();
        this.startMarker3D = null;
      }
      if (this.stopMarker3D) {
        this.stopMarker3D.remove();
        this.stopMarker3D = null;
      }

      this.startMarker3D = new MTK.Marker()
        .setLngLat(bestA)
        .setImage({image: this.svgCircleDataUrl("#00ff00", "black", 15), size: 0.42, anchor: "center"})
        .addTo(this.mtkMap);

      this.stopMarker3D = new MTK.Marker()
        .setLngLat(bestB)
        .setImage({image: this.svgCircleDataUrl("#ff0000", "black", 15), size: 0.42, anchor: "center"})
        .addTo(this.mtkMap);
      if (!bounds.isEmpty()) this.mtkMap.gl.fitBounds(bounds, {padding: 80, duration: 800, maxZoom: 18});
    },
    addOrUpdateHnrMarker(feature) {
      const safe = this.normalizeFeatureCollection(feature);
      if (!safe || !safe.features.length) return;
      feature = safe.features[0];

      const pt = feature.geometry.coordinates;
      if (!Array.isArray(pt) || pt.length !== 2) return;

      if (this.hnrMarker3D) {
        this.hnrMarker3D.remove();
        this.hnrMarker3D = null;
      }

      this.hnrMarker3D = new MTK.LabeledMarker({
        title: feature.properties?.name || "Număr"
      })
        .setLngLat(pt)
        .setImage({id: "marker", anchor: "bottom", size: 1}) // sau image: "https://…/hnr-pin.png"
        .addTo(this.mtkMap);

      // focus lejer pe marker, fără să dai jos linia
      // this.mtkMap.gl.flyTo({ center: pt, zoom: 19, speed: 0.7, curve: 1.6 });
    },
    webMercatorToWgs84([x, y]) {
      const R = 6378137;
      const lon = ((x / R) * 180) / Math.PI;
      const lat = ((2 * Math.atan(Math.exp(y / R)) - Math.PI / 2) * 180) / Math.PI;
      return [lon, lat];
    },
    isLikely3857([a, b]) {
      return Math.abs(a) > 180 || Math.abs(b) > 90;
    },
    maybeSwapLngLat([a, b]) {
      if (Math.abs(a) <= 90 && Math.abs(b) <= 180 && Math.abs(a) > Math.abs(b)) return [b, a];
      return [a, b];
    },
    normalizeCoord([x, y]) {
      if (this.isLikely3857([x, y])) return this.webMercatorToWgs84([x, y]);
      const [lng, lat] = this.maybeSwapLngLat([x, y]);
      if (isNaN(lng) || isNaN(lat) || Math.abs(lng) > 180 || Math.abs(lat) > 90) return null;
      return [lng, lat];
    },
    normalizeCoordsDeep(geom) {
      const fix = c => (Array.isArray(c[0]) ? c.map(fix) : this.normalizeCoord(c));
      const prune = arr =>
        Array.isArray(arr) ? arr.map(prune).filter(v => v !== null && !(Array.isArray(v) && v.length === 0)) : arr;
      let coords = fix(JSON.parse(JSON.stringify(geom.coordinates)));
      coords = prune(coords);
      return {type: geom.type, coordinates: coords};
    },
    normalizeFeature(f) {
      if (!f?.geometry?.coordinates) return null;
      const geometry = this.normalizeCoordsDeep(f.geometry);
      const ok = Array.isArray(geometry.coordinates) && geometry.coordinates.length > 0;
      return ok ? {...f, geometry} : null;
    },
    normalizeFeatureCollection(fc) {
      if (fc?.type === "Feature") {
        const one = this.normalizeFeature(fc);
        return {type: "FeatureCollection", features: one ? [one] : []};
      }
      if (fc?.type === "FeatureCollection") {
        const features = fc.features.map(feat => this.normalizeFeature(feat)).filter(Boolean);
        return {type: "FeatureCollection", features};
      }
      return null;
    },
    normalizeSinglePoi(json) {
      log.start("normalizeSinglePoi() WeatherMTK.vue", {raw: json});

      if (json?.type === "Feature" && json?.geometry?.type && json?.geometry?.coordinates) {
        log.ok("e deja Feature valid");
        log.end();
        return json;
      }

      if (json?.geometry?.type && json?.geometry?.coordinates) {
        log.ok("geometry la rădăcină → Feature");
        log.end();
        return {type: "Feature", geometry: json.geometry, properties: json.properties || {...json}};
      }
      if (json?.properties?.geometry?.type && json?.properties?.geometry?.coordinates) {
        log.ok("geometry în properties → Feature");
        log.end();
        return {type: "Feature", geometry: json.properties.geometry, properties: {...json.properties}};
      }

      if (json?.geom?.type && Array.isArray(json.geom.coordinates)) {
        const crsName = json.geom?.crs?.properties?.name || json.geom?.crs?.name || "";
        const is3857 = /3857|900913/i.test(crsName);
        log.ok(`geom detectat (crs=${crsName || "n/a"}, 3857=${is3857})`);
      }

      const lat = json?.lat ?? json?.latitude;
      const lng = json?.lng ?? json?.lon ?? json?.longitude;
      if (lat != null && lng != null) {
        log.ok("fallback lat/lng simplu");
        log.end();
        return {
          type: "Feature",
          geometry: {type: "Point", coordinates: [Number(lng), Number(lat)]},
          properties: {...json}
        };
      }

      log.warn("NU s-a putut normaliza payload-ul la Feature");
      log.end();
      return null;
    },
    _bearingFrom(a, b, fallback = 0) {
      if (!a || !b || a.length < 2 || b.length < 2) return fallback;

      const [lon1, lat1] = a;
      const [lon2, lat2] = b;

      const toRad = d => (d * Math.PI) / 180;
      const toDeg = r => (r * 180) / Math.PI;

      const φ1 = toRad(lat1);
      const φ2 = toRad(lat2);
      const Δλ = toRad(lon2 - lon1);

      const y = Math.sin(Δλ) * Math.cos(φ2);
      const x = Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ);

      let θ = toDeg(Math.atan2(y, x));
      if (Number.isNaN(θ)) θ = fallback;

      let bearing = (θ + 360) % 360;

      if (this._lastBearing == null) {
        this._lastBearing = bearing;
        return bearing;
      }
      const diff = ((bearing - this._lastBearing + 540) % 360) - 180;
      const alpha = 0.25;
      const smoothed = (this._lastBearing + diff * alpha + 360) % 360;

      this._lastBearing = smoothed;
      return smoothed;
    },
    _getElevAtIndex(elevData, i) {
      if (!elevData) return 0;
      if (Array.isArray(elevData?.samples) && elevData.samples[i]?.elevation != null)
        return elevData.samples[i].elevation;
      if (Array.isArray(elevData?.points) && elevData.points[i]?.elev != null) return elevData.points[i].elev;
      if (Array.isArray(elevData?.elevations) && elevData.elevations[i] != null) return elevData.elevations[i];
      return 0;
    },

    _haversine(a, b) {
      const toRad = d => (d * Math.PI) / 180;
      const R = 6371000;
      const dLat = toRad(b[1] - a[1]);
      const dLng = toRad(b[0] - a[0]);
      const s1 = Math.sin(dLat / 2),
        s2 = Math.sin(dLng / 2);
      const aa = s1 * s1 + Math.cos(toRad(a[1])) * Math.cos(toRad(b[1])) * s2 * s2;
      return 2 * R * Math.asin(Math.min(1, Math.sqrt(aa)));
    },

    _buildDistanceTable(coords) {
      const cum = [0];
      let total = 0;
      for (let i = 1; i < coords.length; i++) {
        total += this._haversine(coords[i - 1], coords[i]);
        cum.push(total);
      }
      return {total, cum};
    },

    _pointAtDistance(coords, cum, d) {
      if (d <= 0) return coords[0];
      const last = cum[cum.length - 1];
      if (d >= last) return coords[coords.length - 1];
      let i = 1;
      while (i < cum.length && cum[i] < d) i++;
      const d0 = cum[i - 1],
        d1 = cum[i];
      const t = (d - d0) / Math.max(1e-6, d1 - d0); // 0..1 pe segment [i-1, i]
      const a = coords[i - 1],
        b = coords[i];
      return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t];
    },
    _fmtDuration(ms) {
      const s = Math.round(ms / 1000);
      const h = Math.floor(s / 3600);
      const m = Math.floor((s % 3600) / 60);
      const ss = s % 60;
      return [h ? `${h}h` : null, m || h ? `${m}m` : null, !h && !m ? `${ss}s` : null].filter(Boolean).join(" ");
    },
    setupFlightControl(polyline = null, lineWidth = 30, {moveCamera = true} = {}) {
      console.log("setupFlightControl() called", {
        moveCamera
      });

      if (!this.flightControl) {
        this.flightControl = new MTK.FlightControl();
        this.flightControl.addTo(this.mtkMap);

        this._mountFlightControlToHost();

        this.flightControl.on("update", event => {
          const progress = event?.progress ?? 0;
          this.lastProgress = progress;

          if (this.elevationProfile?.updateFlightMarker) {
            this.elevationProfile.updateFlightMarker(progress);
          }

          if (progress >= 1 && !this.hasResetAfterFlight) {
            this.hasResetAfterFlight = true;

            setTimeout(() => {
              this.resetCameraTo2DNorth();
            }, 300);
          }
        });
      }

      if (!polyline) return;

      if (polyline.options) {
        polyline.options.width = lineWidth;
      }

      const firstCoord = polyline?.lngLats?.[0];

      if (!firstCoord) {
        console.warn("[FlightControl] Polyline fără coordonate");
        return;
      }

      const marker = new MTK.Marker().setLngLat(firstCoord);

      marker.setImage({
        image:
          "data:image/svg+xml;base64," +
          btoa(`
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
          <circle
            cx="50"
            cy="50"
            r="15"
            fill="#00ff00"
            stroke="black"
            stroke-width="5"
          />
        </svg>
      `),
        size: 0.42,
        anchor: "center"
      });

      this.flightControl.setPolyline(polyline);
      this.flightControl.setMarker(marker);

      if (this.elevationProfile?.setRouteFlight) {
        this.elevationProfile.setRouteFlight(this.flightControl);
      }

      if (moveCamera && this.mtkMap?.gl && polyline.lngLats.length > 0) {
        const gl = this.mtkMap.gl;
        const isMobile = window.innerWidth <= 768;

        const startCoord = polyline.lngLats[0];
        const nextCoord = polyline.lngLats[1] ?? polyline.lngLats[0];

        const bearing = this._bearingFrom(startCoord, nextCoord, 0);

        gl.flyTo({
          center: startCoord,
          zoom: isMobile ? 16.5 : 17,
          speed: 0.4,
          curve: 1,
          pitch: isMobile ? 60 : 65,
          bearing,
          offset: isMobile ? [0, 240] : [0, 0],
          essential: true
        });
      }

      console.log("FlightControl: setat polyline și marker", {moveCamera});
    },
    getFlightFollowOffset() {
      const isMobile = window.innerWidth <= 760;

      if (isMobile) {
        // punctul verde va sta jos, pe centru
        return [0, 240];
      }

      return [0, 0];
    },
    getCoordAtProgress(coords, progress = 0) {
      if (!Array.isArray(coords) || !coords.length) return null;
      if (coords.length === 1) return coords[0];

      const p = Math.max(0, Math.min(1, progress));
      const idx = p * (coords.length - 1);
      const i0 = Math.floor(idx);
      const i1 = Math.min(i0 + 1, coords.length - 1);
      const t = idx - i0;

      const a = coords[i0];
      const b = coords[i1];

      return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t];
    },
    emitFlightControlButton() {
      if (!this.flightControl || !this.flightControl._container) {
        console.warn("FlightControl not initialized or no DOM container");
        return;
      }
      const buttonElement = this.flightControl._container;
      this.$root.$emit("mtkFlightControlReady", buttonElement);
    },
    //nou26.01
    createElevationProfile(polyline) {
      if (!polyline?.lngLats || polyline.lngLats.length < 2) return;

      const host = this.elevationHostEl;
      if (!host) {
        setTimeout(() => this.ensureElevationProfile(), 120);
        return;
      }

      if (this.elevationProfile) {
        try {
          this.elevationProfile.remove();
        } catch {
          console.error("Error loading profile");
        }
        this.elevationProfile = null;
      }

      this.elevationProfile = new MTK.ElevationProfile({surface: true});

      this.elevationProfile.setPolyline(polyline, err => {
        if (err) {
          console.error("Error loading profile", err);
          return;
        }

        host.innerHTML = "";
        this.elevationProfile.addTo(host);
        this.elevationProfile.setMap?.(this.mtkMap);

        if (this.flightControl) {
          this.elevationProfile.setRouteFlight?.(this.flightControl);
        }

        setTimeout(() => this.elevationProfile?.resize?.(), 0);
      });
    },

    ensureElevationProfile() {
      if (!this.currentSelectedPolyline) return;
      if (!this.elevationHostEl) return;

      const alreadyMounted = !!this.elevationHostEl.querySelector(".mtk-elevation-profile");
      if (!this.elevationProfile || !alreadyMounted) {
        this.createElevationProfile(this.currentSelectedPolyline);
      } else {
        this.elevationProfile.setMap?.(this.mtkMap);
        this.elevationProfile.setRouteFlight?.(this.flightControl);
        this.elevationProfile.resize?.();
      }
    },
    enableWeatherLayer() {
      if (this.weatherActive || !this.mtkMap) return;
      this.weatherActive = true;

      const et = document.querySelector(".mtk-daytime-control");
      if (et) {
        et.style.display = "block";
      }
      this._translateDaytimeSoon();
    },

    disableWeatherLayer() {
      if (!this.weatherActive) return;
      this.weatherControl = null;
      // this.weatherControl.setWeather("null");

      const group = document.querySelector(".mtk-weather-control-group");
      if (group) {
        const overviewBtn = group.querySelector(".mtk-weather-control-overview-button");
        overviewBtn?.click();
        group.style.display = "none";
      }

      const et = document.querySelector(".mtk-daytime-control");
      if (et) {
        et.style.display = "none";
      }

      this.weatherActive = false;
      this.$emit("updateWeatherState", false);
    },

    toggleWeatherLayer() {
      console.trace("toggleWeatherLayer() called");
      if (this.weatherActive) {
        this.disableWeatherLayer();
        // this.weatherControl.setWeather(null);
      } else {
        this.enableWeatherLayer();
        // this.weatherControl.setWeather("overview");
      }
      this.$emit("update:weatherActive", this.weatherActive);
      // this.weatherControl.setWeather(null);
    },
    toPlainCoords(coords) {
      if (Array.isArray(coords)) {
        return coords.map(c => this.toPlainCoords(c));
      }
      return coords;
    },

    addPoisOn3DMap(poisGeoJSON) {
      const rawClustering = Vue.config.item_clustering || this.$cookie.get("item_clustering") || "dynamic";

      const clustering = ["never", "dynamic", "always"].includes(String(rawClustering))
        ? String(rawClustering)
        : "dynamic";

      console.log("[MTK clustering]", {
        rawClustering,
        clustering
      });
      if (!this.mtkMap) {
        console.warn("mtkMap not exist!");
        return {ok: false};
      }

      const safe = this.normalizeFeatureCollection(poisGeoJSON);
      if (!safe || !safe.features.length) {
        console.warn("No valid features after normalization", poisGeoJSON);
        this.clearPOIsFromMap(false);
        return {ok: false};
      }
      poisGeoJSON = safe;

      if (this.poiLayer) {
        this.poiLayer.remove();
        this.poiLayer = null;
      }
      this.removeMtkClusterLayer?.();

      //nou
      this.removeMtkPoiLayer?.();
      this.removeMtkGeometryLayers?.();

      if (this.geometryLineLayer) {
        this.geometryLineLayer.remove();
        this.geometryLineLayer = null;
      }
      if (this.geometryPolygonLayer) {
        this.geometryPolygonLayer.remove();
        this.geometryPolygonLayer = null;
      }
      if (this.startMarker3D) {
        this.startMarker3D.remove();
        this.startMarker3D = null;
      }
      if (this.stopMarker3D) {
        this.stopMarker3D.remove();
        this.stopMarker3D = null;
      }
      this.currentSelectedPolyline = null;

      const markers = [];
      // const polylines = [];
      // const polygons = [];
      const lineFeatures = [];
      const polygonFeatures = [];
      const pointFeatures = [];
      const allCoords = [];

      const boundsAll = new window.maplibregl.LngLatBounds();

      poisGeoJSON.features.forEach(f => {
        const g = f.geometry;
        if (!g) return;

        const name = f.properties?.name || "POI";
        const url_360 = f.properties?.url_360;

        // — Point
        if (g.type === "Point") {
          const [lng, lat] = g.coordinates;
          allCoords.push([lng, lat]);
          boundsAll.extend([lng, lat]);

          pointFeatures.push(f);
          if (clustering !== "never") {
            return;
          }

          const marker = new MTK.LabeledMarker({
            title: name,
            subtitle: f.properties?.subtitle || ""
          }).setLngLat([lng, lat]);

          let imgUrl = f.properties?.icon;
          if (imgUrl && !imgUrl.startsWith("http")) {
            imgUrl = "https://map.map2web.eu" + imgUrl;
          }
          marker.setImage(
            imgUrl
              ? {image: imgUrl, size: 1, anchor: "bottom"}
              : {image: this.svgCircleDataUrl("#0000ff"), size: 1, anchor: "bottom"}
          );
          marker.on?.("mouseover", e => this._showHoverTooltip(name, e));
          marker.on?.("mousemove", e => this._moveHoverTooltip(e));
          marker.on?.("mouseout", () => this._hideHoverTooltip());
          marker.on?.("click", () => this.focusFeatureOnce(f));
          markers.push(marker);
        }
        // — MultiPoint
        if (g.type === "MultiPoint") {
          g.coordinates.forEach(([lng, lat], index) => {
            allCoords.push([lng, lat]);
            boundsAll.extend([lng, lat]);
            const pointFeature = {
              ...f,
              id: `${f.id ?? f.properties?.id ?? "poi"}-${index}`,
              geometry: {
                type: "Point",
                coordinates: [lng, lat]
              },
              properties: {
                ...(f.properties || {}),
                originalGeometryType: "MultiPoint",
                pointIndex: index
              }
            };

            pointFeatures.push(pointFeature);

            if (clustering !== "never") {
              return;
            }

            const marker = new MTK.LabeledMarker({
              title: name,
              subtitle: f.properties?.subtitle || ""
            }).setLngLat([lng, lat]);

            let imgUrl = f.properties?.icon;
            if (imgUrl && !imgUrl.startsWith("http")) {
              imgUrl = "https://map.map2web.eu" + imgUrl;
            }

            marker.setImage(
              imgUrl
                ? {image: imgUrl, size: 1, anchor: "bottom"}
                : {image: this.svgCircleDataUrl("#0000ff"), size: 1, anchor: "bottom"}
            );

            marker.on?.("click", () =>
              this.focusFeatureOnce({
                ...f,
                geometry: {type: "Point", coordinates: [lng, lat]}
              })
            );

            markers.push(marker);
          });
        }
        if (g.type === "LineString") {
          g.coordinates.forEach(coordinate => {
            allCoords.push(coordinate);
            boundsAll.extend(coordinate);
          });

          lineFeatures.push({
            type: "Feature",
            id: f.id ?? f.properties?.id,

            geometry: {
              type: "LineString",
              coordinates: g.coordinates
            },

            properties: {
              ...(f.properties || {}),

              dbLineColor: f.properties?.line_color || f.properties?.color || "#ff0000",

              dbLineWidth: Number(f.properties?.width ?? f.properties?.line_width ?? 3)
            }
          });

          
          const technicalPolyline = this.createTechnicalMtkPolyline(f);

          if (technicalPolyline) {
            this.currentSelectedPolyline = technicalPolyline;
          }
          if (g.coordinates.length >= 2) {
            this.startMarker3D = new MTK.LabeledMarker({
              title: "Start"
            })
              .setLngLat(g.coordinates[0])
              .addTo(this.mtkMap);

            this.stopMarker3D = new MTK.LabeledMarker({
              title: "Stop"
            })
              .setLngLat(g.coordinates[g.coordinates.length - 1])
              .addTo(this.mtkMap);
          }
        }

        if (g.type === "MultiLineString") {
          g.coordinates.forEach(line => {
            line.forEach(coordinate => {
              allCoords.push(coordinate);
              boundsAll.extend(coordinate);
            });
          });

          lineFeatures.push({
            type: "Feature",
            id: f.id ?? f.properties?.id,

            geometry: {
              type: "MultiLineString",
              coordinates: g.coordinates
            },

            properties: {
              ...(f.properties || {}),

              dbLineColor: f.properties?.line_color || f.properties?.color || "#ff0000",

              dbLineWidth: Number(f.properties?.width ?? f.properties?.line_width ?? 3)
            }
          });

          const technicalPolyline = this.createTechnicalMtkPolyline(f);

          if (technicalPolyline) {
            this.currentSelectedPolyline = technicalPolyline;
          }
        }

        if (g.type === "Polygon") {
          g.coordinates.forEach(ring => {
            ring.forEach(coordinate => {
              allCoords.push(coordinate);
              boundsAll.extend(coordinate);
            });
          });

          polygonFeatures.push({
            type: "Feature",
            id: f.id ?? f.properties?.id,

            geometry: {
              type: "Polygon",
              coordinates: g.coordinates
            },

            properties: {
              ...(f.properties || {}),

              dbFillColor: f.properties?.fill_color || "#00ff00",

              dbFillOpacity: Number(f.properties?.fill_opacity ?? 0.5),

              dbLineColor: f.properties?.line_color || "#000000",

              dbLineWidth: Number(f.properties?.width ?? f.properties?.line_width ?? 2)
            }
          });
        }
        if (g.type === "MultiPolygon") {
          g.coordinates.forEach(polygon => {
            polygon.forEach(ring => {
              ring.forEach(coordinate => {
                allCoords.push(coordinate);
                boundsAll.extend(coordinate);
              });
            });
          });

          polygonFeatures.push({
            type: "Feature",
            id: f.id ?? f.properties?.id,

            geometry: {
              type: "MultiPolygon",
              coordinates: g.coordinates
            },

            properties: {
              ...(f.properties || {}),

              dbFillColor: f.properties?.fill_color || "#00ff00",

              dbFillOpacity: Number(f.properties?.fill_opacity ?? 0.3),

              dbLineColor: f.properties?.line_color || "#000000",

              dbLineWidth: Number(f.properties?.width ?? f.properties?.line_width ?? 1)
            }
          });
        }

        // IMPORTANT: închide poisGeoJSON.features.forEach(...)
      });

      // add layers
      // add layers

      const pointsCollection = {
        type: "FeatureCollection",
        features: pointFeatures
      };

      if (clustering === "never" && pointFeatures.length) {
        this.addMtkPoiLayer(pointsCollection).catch(error => {
          console.error("[MTK POI never] Nu s-au putut afișa punctele:", error);
        });
      } else if (pointFeatures.length) {
        this.addMtkClusterLayer(pointsCollection, clustering).catch(error => {
          console.error(`[MTK cluster ${clustering}] Nu s-au putut afișa punctele:`, error);
        });
      }
      if (lineFeatures.length || polygonFeatures.length) {
        this.addMtkGeometryLayers({
          type: "FeatureCollection",
          features: [...polygonFeatures, ...lineFeatures]
        });
      }

      return {
        ok: true,
        clustering,
        points: pointFeatures.length,
        lines: lineFeatures.length,
        polygons: polygonFeatures.length
      };
    },
    async addMtkPoiLayer(featureCollection) {
      const gl = this.mtkMap?.gl;

      if (!gl || !featureCollection?.features?.length) {
        return {ok: false};
      }

      const sourceId = "database-pois-source-never";

      const iconLayerId = "database-pois-icons-never";

      const fallbackLayerId = "database-pois-fallback-never";

      this.removeMtkPoiLayer();

      // const data = JSON.parse(JSON.stringify(featureCollection));
      const data = this.sanitizeGeoJsonForMap(featureCollection);

      if (!data.features.length) {
        console.warn("[MTK POI never] Nu există features valide după sanitizare");
        return;
      }

      await Promise.all(
        data.features.map(async (feature, index) => {
          if (feature?.geometry?.type !== "Point") {
            return;
          }

          const iconUrl = this.getDatabasePoiIconUrl(feature);

          if (!iconUrl) {
            feature.properties = {
              ...(feature.properties || {}),
              hasDatabaseIcon: false
            };

            return;
          }

          const iconId = this.getDatabasePoiIconId(feature, index);

          const loaded = await this.loadMtkPoiImage(gl, iconId, iconUrl);

          feature.properties = {
            ...(feature.properties || {}),
            mtkIconId: loaded ? iconId : "",
            hasDatabaseIcon: Boolean(loaded)
          };
        })
      );

      if (gl.getLayer(iconLayerId)) {
        gl.removeLayer(iconLayerId);
      }

      if (gl.getLayer(fallbackLayerId)) {
        gl.removeLayer(fallbackLayerId);
      }

      if (gl.getSource(sourceId)) {
        gl.removeSource(sourceId);
      }

      gl.addSource(sourceId, {
        type: "geojson",
        data
      });

      gl.addLayer({
        id: fallbackLayerId,
        type: "circle",
        source: sourceId,

        filter: ["!=", ["get", "hasDatabaseIcon"], true],

        paint: {
          "circle-radius": 8,
          "circle-color": "#d71920",
          "circle-stroke-color": "#ffffff",
          "circle-stroke-width": 2
        }
      });

      gl.addLayer({
        id: iconLayerId,
        type: "symbol",
        source: sourceId,

        filter: ["==", ["get", "hasDatabaseIcon"], true],

        layout: {
          "icon-image": ["get", "mtkIconId"],
          "icon-size": 1,
          "icon-anchor": "bottom",
          "icon-allow-overlap": true,
          "icon-ignore-placement": true
        }
      });

      this._onMtkPoiNeverClick = event => {
        const rawFeature = event.features?.[0];

        if (!rawFeature) {
          return;
        }

        this.focusFeatureOnce({
          type: "Feature",
          id: rawFeature.id,
          geometry: rawFeature.geometry,
          properties: rawFeature.properties || {}
        });
      };

      this._onMtkPoiNeverMouseMove = event => {
        const feature = event.features?.[0];

        if (!feature) {
          this.scheduleHidePanoramaHover();
          return;
        }

        console.log("[PANORAMA POINT]", feature.properties);

        this.showPanoramaForFeature(feature, event.point);

        if (this.panoramaHover.visible) {
          gl.getCanvas().style.cursor = "pointer";
        }
      };

      this._onMtkPoiNeverMouseLeave = () => {
        this.scheduleHidePanoramaHover();
      };

      this._onMtkPoiNeverMouseLeave = () => {
        this.scheduleHidePanoramaHover();
      };

      [iconLayerId, fallbackLayerId].forEach(layerId => {
        gl.on("click", layerId, this._onMtkPoiNeverClick);

        gl.on("mousemove", layerId, this._onMtkPoiNeverMouseMove);

        gl.on("mouseleave", layerId, this._onMtkPoiNeverMouseLeave);
      });

      this.moveDatabaseLayersAboveWmts();
      gl.triggerRepaint?.();

      return {
        ok: true,
        points: data.features.length
      };
    },
    removeMtkPoiLayer() {
      const gl = this.mtkMap?.gl;

      if (!gl) {
        return;
      }

      const sourceId = "database-pois-source-never";

      const iconLayerId = "database-pois-icons-never";

      const fallbackLayerId = "database-pois-fallback-never";

      try {
        [iconLayerId, fallbackLayerId].forEach(layerId => {
          if (this._onMtkPoiNeverClick) {
            gl.off("click", layerId, this._onMtkPoiNeverClick);
          }

          if (this._onMtkPoiNeverMouseEnter) {
            gl.off("mouseenter", layerId, this._onMtkPoiNeverMouseEnter);
          }

          if (this._onMtkPoiNeverMouseLeave) {
            gl.off("mouseleave", layerId, this._onMtkPoiNeverMouseLeave);
          }
        });

        [iconLayerId, fallbackLayerId].forEach(layerId => {
          if (gl.getLayer?.(layerId)) {
            gl.removeLayer(layerId);
          }
        });

        if (gl.getSource?.(sourceId)) {
          gl.removeSource(sourceId);
        }
      } catch (error) {
        console.warn("[MTK POI never] Remove failed:", error);
      }

      this._onMtkPoiNeverClick = null;
      this._onMtkPoiNeverMouseEnter = null;
      this._onMtkPoiNeverMouseLeave = null;
    },
    createTechnicalMtkPolyline(feature) {
      const geometry = feature?.geometry;

      if (!geometry || !["LineString", "MultiLineString"].includes(geometry.type)) {
        return null;
      }

      let coordinates = null;

      if (geometry.type === "LineString") {
        coordinates = geometry.coordinates;
      } else {
        coordinates = this._getBestLineCoordsFromFeatures([feature]);
      }

      if (!Array.isArray(coordinates) || coordinates.length < 2) {
        return null;
      }

      const color = feature.properties?.line_color || feature.properties?.color || "#ff0000";

      const width = Number(feature.properties?.width ?? feature.properties?.line_width ?? 3);

      const polyline = new MTK.Polyline({
        color,
        width,
        clickable: true
      });

      polyline.setLngLats(coordinates);

      return polyline;
    },
    addMtkGeometryLayers(featureCollection) {
      console.log("========== addMtkGeometryLayers START ==========");

      console.log("[GEOMETRY RAW]", {
        count: featureCollection?.features?.length,
        features: featureCollection?.features?.map(f => ({
          id: f.id ?? f.properties?.id,
          name: f.properties?.name,
          type: f.geometry?.type,
          polygons: f.geometry?.coordinates?.length
        }))
      });

      const data = this.sanitizeGeoJsonForMap(featureCollection);

      console.log("[GEOMETRY SANITIZED]", {
        count: data?.features?.length,
        features: data?.features?.map(f => ({
          id: f.id ?? f.properties?.id,
          name: f.properties?.name,
          type: f.geometry?.type,
          polygons: f.geometry?.coordinates?.length
        }))
      });
      // const data = this.sanitizeGeoJsonForMap(featureCollection);

      if (!data.features.length) {
        return;
      }
      const gl = this.mtkMap?.gl;

      if (!gl || !featureCollection?.features?.length) {
        return;
      }

      const sourceId = "database-geometries-source";

      const polygonFillLayerId = "database-polygons-fill";

      const polygonOutlineLayerId = "database-polygons-outline";

      const lineLayerId = "database-lines-layer";

      this.removeMtkGeometryLayers();

      gl.addSource(sourceId, {
        type: "geojson",
        data
      });

      gl.addLayer({
        id: polygonFillLayerId,
        type: "fill",
        source: sourceId,

        filter: ["==", ["geometry-type"], "Polygon"],

        paint: {
          "fill-color": ["coalesce", ["get", "dbFillColor"], "#00ff00"],

          "fill-opacity": ["coalesce", ["to-number", ["get", "dbFillOpacity"]], 0.5]
        }
      });

      gl.addLayer({
        id: polygonOutlineLayerId,
        type: "line",
        source: sourceId,

        filter: ["==", ["geometry-type"], "Polygon"],

        layout: {
          "line-cap": "round",
          "line-join": "round"
        },

        paint: {
          "line-color": ["coalesce", ["get", "dbLineColor"], "#000000"],

          "line-width": ["coalesce", ["to-number", ["get", "dbLineWidth"]], 2]
        }
      });

      gl.addLayer({
        id: lineLayerId,
        type: "line",
        source: sourceId,

        filter: ["==", ["geometry-type"], "LineString"],

        layout: {
          "line-cap": "round",
          "line-join": "round"
        },

        paint: {
          "line-color": ["coalesce", ["get", "dbLineColor"], "#ff0000"],

          "line-width": ["coalesce", ["to-number", ["get", "dbLineWidth"]], 3]
        }
      });

      this._onMtkGeometryClick = event => {
        const rawFeature = event.features?.[0];

        if (!rawFeature) {
          return;
        }

        const feature = {
          type: "Feature",
          id: rawFeature.id,
          geometry: rawFeature.geometry,
          properties: rawFeature.properties || {}
        };

        this.focusFeatureOnce(feature);

        const type = feature.geometry?.type;

        if (type === "LineString" || type === "MultiLineString") {
          this.currentSelectedPolyline = this.createTechnicalMtkPolyline(feature);

          if (this.currentSelectedPolyline) {
            const width = Number(
              feature.properties?.width ?? feature.properties?.line_width ?? feature.properties?.dbLineWidth ?? 3
            );

            this.setupFlightControl(this.currentSelectedPolyline, width, {moveCamera: false});

            this.ensureElevationProfile?.();
          }
        }
      };

      [polygonFillLayerId, polygonOutlineLayerId, lineLayerId].forEach(layerId => {
        gl.on("click", layerId, this._onMtkGeometryClick);
      });

      this.moveDatabaseLayersAboveWmts();
      this.setupPanoramaLineHover();
      gl.triggerRepaint?.();

      requestAnimationFrame(() => {
        gl.triggerRepaint?.();
      });

      setTimeout(() => {
        gl.triggerRepaint?.();
      }, 50);
    },
    removeMtkGeometryLayers() {
      const gl = this.mtkMap?.gl;

      if (!gl) {
        return;
      }

      const sourceId = "database-geometries-source";

      const layerIds = ["database-lines-layer", "database-polygons-outline", "database-polygons-fill"];
      if (this._panoramaMouseMove && gl.getLayer("database-lines-layer")) {
        gl.off("mousemove", "database-lines-layer", this._panoramaMouseMove);
      }

      if (this._panoramaMouseLeave && gl.getLayer("database-lines-layer")) {
        gl.off("mouseleave", "database-lines-layer", this._panoramaMouseLeave);
      }

      this._panoramaMouseMove = null;
      this._panoramaMouseLeave = null;

      this.hidePanoramaHover();

      try {
        layerIds.forEach(layerId => {
          if (this._onMtkGeometryClick) {
            gl.off("click", layerId, this._onMtkGeometryClick);
          }
        });

        layerIds.forEach(layerId => {
          if (gl.getLayer?.(layerId)) {
            gl.removeLayer(layerId);
          }
        });

        if (gl.getSource?.(sourceId)) {
          gl.removeSource(sourceId);
        }
      } catch (error) {
        console.warn("[MTK geometry] Remove failed:", error);
      }

      this._onMtkGeometryClick = null;
    },
    sanitizeGeoJsonForMap(featureCollection) {
      if (!featureCollection || !Array.isArray(featureCollection.features)) {
        return {
          type: "FeatureCollection",
          features: []
        };
      }

      const sanitizeValue = value => {
        if (value == null || typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
          return value;
        }

        if (Array.isArray(value)) {
          return value.map(item => sanitizeValue(item)).filter(item => item !== undefined);
        }

        /*
         * Nu trimitem obiecte complexe precum:
         * feature, poi, olFeature, map, layer etc.
         */
        return undefined;
      };

      return {
        type: "FeatureCollection",

        features: featureCollection.features
          .map((feature, index) => {
            const geometry = feature?.geometry;

            if (!geometry || !geometry.type || !Array.isArray(geometry.coordinates)) {
              return null;
            }

            const originalProperties = feature.properties || {};

            const properties = {};

            Object.keys(originalProperties).forEach(key => {
              /*
               * Aceste câmpuri produc frecvent referințe circulare.
               */
              if (["feature", "poi", "olFeature", "map", "layer", "source"].includes(key)) {
                return;
              }

              const safeValue = sanitizeValue(originalProperties[key]);

              if (safeValue !== undefined) {
                properties[key] = safeValue;
              }
            });

            return {
              type: "Feature",

              id: feature.id ?? originalProperties.id ?? `db-feature-${index}`,

              geometry: {
                type: geometry.type,
                coordinates: geometry.coordinates
              },

              properties
            };
          })
          .filter(Boolean)
      };
    },
    async addMtkClusterLayer(featureCollection, mode = "dynamic") {
      const gl = this.mtkMap?.gl;

      if (
        !gl ||
        !featureCollection ||
        !Array.isArray(featureCollection.features) ||
        !featureCollection.features.length
      ) {
        return;
      }

      const sourceId = "database-pois-source";
      const clusterLayerId = "database-pois-clusters";
      const countLayerId = "database-pois-cluster-count";
      const singleIconLayerId = "database-pois-single-icon";
      const singleFallbackLayerId = "database-pois-single-fallback";

      this.removeMtkClusterLayer();

      /*
       * Copiem datele pentru a nu modifica direct prop-ul primit.
       */
      // const data = JSON.parse(JSON.stringify(featureCollection));
      const data = this.sanitizeGeoJsonForMap(featureCollection);

      if (!data.features.length) {
        console.warn("[MTK cluster] Nu există features valide după sanitizare");
        return;
      }

      /*
       * Încărcăm iconurile din DB și punem iconId
       * în proprietățile fiecărui feature.
       */
      await Promise.all(
        data.features.map(async (feature, index) => {
          if (feature?.geometry?.type !== "Point") {
            return;
          }

          const iconUrl = this.getDatabasePoiIconUrl(feature);

          if (!iconUrl) {
            feature.properties = {
              ...(feature.properties || {}),
              hasDatabaseIcon: false
            };

            return;
          }

          const iconId = this.getDatabasePoiIconId(feature, index);

          const loaded = await this.loadMtkPoiImage(gl, iconId, iconUrl);

          feature.properties = {
            ...(feature.properties || {}),
            mtkIconId: loaded ? iconId : "",
            hasDatabaseIcon: loaded,
            resolvedIconUrl: iconUrl
          };
        })
      );

      gl.addSource(sourceId, {
        type: "geojson",
        data,

        cluster: true,
        clusterRadius: 50,
        clusterMaxZoom: mode === "always" ? 22 : 16
      });

      gl.addLayer({
        id: clusterLayerId,
        type: "circle",
        source: sourceId,

        filter: ["has", "point_count"],

        paint: {
          "circle-radius": ["step", ["get", "point_count"], 18, 10, 22, 50, 28],

          "circle-color": "#d71920",
          "circle-stroke-color": "#ffffff",
          "circle-stroke-width": 2
        }
      });

      gl.addLayer({
        id: countLayerId,
        type: "symbol",
        source: sourceId,

        filter: ["has", "point_count"],

        layout: {
          "text-field": ["get", "point_count_abbreviated"],
          "text-size": 14,
          "text-allow-overlap": true,
          "text-ignore-placement": true
        },

        paint: {
          "text-color": "#ffffff"
        }
      });
      gl.addLayer({
        id: singleIconLayerId,
        type: "symbol",
        source: sourceId,

        filter: ["all", ["!", ["has", "point_count"]], ["==", ["get", "hasDatabaseIcon"], true]],

        layout: {
          "icon-image": ["get", "mtkIconId"],
          "icon-size": 1,
          "icon-anchor": "bottom",
          "icon-allow-overlap": true,
          "icon-ignore-placement": true
        }
      });

      gl.addLayer({
        id: singleFallbackLayerId,
        type: "circle",
        source: sourceId,

        filter: [
          "all",
          ["!", ["has", "point_count"]],
          ["any", ["!", ["has", "hasDatabaseIcon"]], ["==", ["get", "hasDatabaseIcon"], false]]
        ],

        paint: {
          "circle-radius": 8,
          "circle-color": "#d71920",
          "circle-stroke-color": "#ffffff",
          "circle-stroke-width": 2
        }
      });

      /*
       * Click pe cluster.
       */
      this._onMtkClusterClick = event => {
        const feature = event.features?.[0];

        const clusterId = feature?.properties?.cluster_id;

        const coordinates = feature?.geometry?.coordinates;

        if (clusterId == null || !Array.isArray(coordinates)) {
          return;
        }

        const source = gl.getSource(sourceId);

        source.getClusterExpansionZoom(clusterId, (error, zoom) => {
          if (error) {
            console.warn("[MTK cluster] Expansion error:", error);
            return;
          }

          gl.easeTo({
            center: coordinates,
            zoom,
            duration: 500
          });
        });
      };

      /*
       * Click pe POI individual.
       */
      this._onMtkSinglePoiClick = event => {
        const feature = event.features?.[0];

        if (!feature) {
          return;
        }

        this.focusFeatureOnce({
          type: "Feature",
          id: feature.id,
          geometry: feature.geometry,
          properties: feature.properties || {}
        });
      };

      this._onMtkPoiMouseEnter = () => {
        gl.getCanvas().style.cursor = "pointer";
      };

      this._onMtkPoiMouseLeave = () => {
        gl.getCanvas().style.cursor = "";
      };

      gl.on("click", clusterLayerId, this._onMtkClusterClick);

      gl.on("click", singleIconLayerId, this._onMtkSinglePoiClick);

      gl.on("click", singleFallbackLayerId, this._onMtkSinglePoiClick);

      [clusterLayerId, singleIconLayerId, singleFallbackLayerId].forEach(layerId => {
        gl.on("mouseenter", layerId, this._onMtkPoiMouseEnter);

        gl.on("mouseleave", layerId, this._onMtkPoiMouseLeave);
      });

      gl.triggerRepaint?.();
    },
    removeMtkClusterLayer() {
      const gl = this.mtkMap?.gl;

      if (!gl) {
        return;
      }

      const sourceId = "database-pois-source";
      const clusterLayerId = "database-pois-clusters";
      const countLayerId = "database-pois-cluster-count";
      const singleIconLayerId = "database-pois-single-icon";
      const singleFallbackLayerId = "database-pois-single-fallback";

      try {
        if (this._onMtkClusterClick) {
          gl.off("click", clusterLayerId, this._onMtkClusterClick);
        }

        if (this._onMtkSinglePoiClick) {
          gl.off("click", singleIconLayerId, this._onMtkSinglePoiClick);

          gl.off("click", singleFallbackLayerId, this._onMtkSinglePoiClick);
        }

        if (this._onMtkPoiMouseEnter) {
          [clusterLayerId, singleIconLayerId, singleFallbackLayerId].forEach(layerId => {
            gl.off("mouseenter", layerId, this._onMtkPoiMouseEnter);
          });
        }

        if (this._onMtkPoiMouseLeave) {
          [clusterLayerId, singleIconLayerId, singleFallbackLayerId].forEach(layerId => {
            gl.off("mouseleave", layerId, this._onMtkPoiMouseLeave);
          });
        }

        [countLayerId, singleIconLayerId, singleFallbackLayerId, clusterLayerId].forEach(layerId => {
          if (gl.getLayer?.(layerId)) {
            gl.removeLayer(layerId);
          }
        });

        if (gl.getSource?.(sourceId)) {
          gl.removeSource(sourceId);
        }
      } catch (error) {
        console.warn("[MTK cluster] Eroare la eliminare:", error);
      }

      this._onMtkClusterClick = null;
      this._onMtkSinglePoiClick = null;
      this._onMtkPoiMouseEnter = null;
      this._onMtkPoiMouseLeave = null;
    },
    focusMapAfterAddingInitial(ctx, opts = {}) {
      if (!ctx?.ok || !this.mtkMap?.gl) return;

      const gl = this.mtkMap.gl;
      const {
        paddingMulti = 150,
        durationMulti = 1000,
        paddingSingle = 100,
        durationSingle = 1600,
        speedPoint = 4,
        curvePoint = 1.05
      } = opts;

      if (ctx.featuresCount > 1 && ctx.boundsAll) {
        this._fittingNow = true;
        this.skipNextAutoFit = true;
        gl.fitBounds(ctx.boundsAll, {padding: paddingMulti, duration: durationMulti});
        gl.once("moveend", () =>
          setTimeout(() => {
            this._fittingNow = false;
            this.skipNextAutoFit = false;
          }, 100)
        );
        return;
      }

      const feature = ctx.firstFeature;
      const geometry = feature?.geometry;
      if (!geometry) return;

      const bounds = new window.maplibregl.LngLatBounds();
      let moved = false;

      const lineWidth = Number(feature.properties?.width ?? feature.properties?.line_width ?? 3);

      // — Point → flyTo with zoom
      if (geometry.type === "Point") {
        const [lng, lat] = geometry.coordinates;
        this._fittingNow = true;
        this.skipNextAutoFit = true;
        gl.flyTo({
          center: [lng, lat],
          zoom: 13,
          speed: speedPoint,
          curve: curvePoint
        });
        gl.once("moveend", () =>
          setTimeout(() => {
            this._fittingNow = false;
            this.skipNextAutoFit = false;
          }, 100)
        );
        return;
      }

      // — LineString
      if (geometry.type === "LineString") {
        geometry.coordinates.forEach(c => bounds.extend(c));
        this.currentSelectedPolyline = new MTK.Polyline({
          color: feature.properties?.line_color || "#ff0000",
          width: lineWidth
          // width: feature.properties?.width || 3,
        });
        this.currentSelectedPolyline.setLngLats(geometry.coordinates);
        this.createElevationProfile?.(this.currentSelectedPolyline);
        // this.setupFlightControl?.(this.currentSelectedPolyline);
        this.setupFlightControl?.(this.currentSelectedPolyline, lineWidth);
      }

      // — MultiLineString
      if (geometry.type === "MultiLineString") {
        const flatCoords = geometry.coordinates.flat();
        flatCoords.forEach(c => bounds.extend(c));
        this.currentSelectedPolyline = new MTK.Polyline({
          color: feature.properties?.line_color || "#ff0000",
          width: lineWidth
          // width: feature.properties?.width || 3,
        });
        this.currentSelectedPolyline.setLngLats(flatCoords);
        this.createElevationProfile?.(this.currentSelectedPolyline);
        // this.setupFlightControl?.(this.currentSelectedPolyline);
        this.setupFlightControl?.(this.currentSelectedPolyline, lineWidth);

        if (!bounds.isEmpty()) {
          this._fittingNow = true;
          this.skipNextAutoFit = true;
          gl.fitBounds(bounds, {
            padding: paddingSingle,
            duration: durationSingle,
            linear: false,
            easing: t => 1 - Math.pow(1 - t, 2)
          });
          gl.once("moveend", () =>
            setTimeout(() => {
              this._fittingNow = false;
              this.skipNextAutoFit = false;
            }, 100)
          );
          moved = true;
        }
      }

      // — Polygon
      if (geometry.type === "Polygon") {
        geometry.coordinates.forEach(ring => ring.forEach(c => bounds.extend(c)));
      }

      // — MultiPolygon
      if (geometry.type === "MultiPolygon") {
        geometry.coordinates.forEach(poly => poly.forEach(ring => ring.forEach(c => bounds.extend(c))));
      }

      // Fallback comun (Poligon / MultiPoligon sau cazuri neacoperite)
      if (!moved && !bounds.isEmpty()) {
        this._fittingNow = true;
        this.skipNextAutoFit = true;
        gl.fitBounds(bounds, {
          padding: paddingSingle,
          duration: durationSingle,
          linear: false,
          easing: t => 1 - Math.pow(1 - t, 2)
        });
        gl.once("moveend", () =>
          setTimeout(() => {
            this._fittingNow = false;
            this.skipNextAutoFit = false;
          }, 100)
        );
      }
    },
    focusMapAfterAdding(ctx, opts = {}) {
      if (!ctx?.ok || !this.mtkMap?.gl) return;

      const gl = this.mtkMap.gl;

      const {
        paddingMulti = null,
        durationMulti = 1000,
        paddingSingle = null,
        durationSingle = 1600,
        speedPoint = 4,
        curvePoint = 1.05
      } = opts;

      const feature = ctx.firstFeature;
      const geometry = feature?.geometry;
      if (!geometry) return;

      const fitPadding = paddingSingle || this.getFitPadding(geometry.type);
      const fitPaddingMulti = paddingMulti || this.getFitPadding(geometry.type);

      if (ctx.featuresCount > 1 && ctx.boundsAll) {
        this._fittingNow = true;
        this.skipNextAutoFit = true;

        gl.fitBounds(ctx.boundsAll, {
          padding: fitPaddingMulti,
          duration: durationMulti
        });

        gl.once("moveend", () =>
          setTimeout(() => {
            this._fittingNow = false;
            this.skipNextAutoFit = false;
          }, 100)
        );
        return;
      }

      const bounds = new window.maplibregl.LngLatBounds();
      let moved = false;

      const lineWidth = Number(feature.properties?.width ?? feature.properties?.line_width ?? 3);

      if (geometry.type === "Point") {
        const [lng, lat] = geometry.coordinates;
        this._fittingNow = true;
        this.skipNextAutoFit = true;

        gl.flyTo({
          center: [lng, lat],
          zoom: 13,
          speed: speedPoint,
          curve: curvePoint
        });

        gl.once("moveend", () =>
          setTimeout(() => {
            this._fittingNow = false;
            this.skipNextAutoFit = false;
          }, 100)
        );
        return;
      }

      if (geometry.type === "LineString") {
        geometry.coordinates.forEach(c => bounds.extend(c));
        this.currentSelectedPolyline = new MTK.Polyline({
          color: feature.properties?.line_color || "#ff0000",
          width: lineWidth
          // width: feature.properties?.width || 3,
        });
        this.currentSelectedPolyline.setLngLats(geometry.coordinates);
        this.createElevationProfile?.(this.currentSelectedPolyline);
        this.setupFlightControl?.(this.currentSelectedPolyline, lineWidth);
        // this.setupFlightControl?.(this.currentSelectedPolyline);
      }

      if (geometry.type === "MultiLineString") {
        const flatCoords = geometry.coordinates.flat();
        flatCoords.forEach(c => bounds.extend(c));

        this.currentSelectedPolyline = new MTK.Polyline({
          color: feature.properties?.line_color || "#ff0000",
          width: lineWidth
          // width: feature.properties?.width || 3,
        });
        this.currentSelectedPolyline.setLngLats(flatCoords);
        this.createElevationProfile?.(this.currentSelectedPolyline);
        this.setupFlightControl?.(this.currentSelectedPolyline, lineWidth);
        // this.setupFlightControl?.(this.currentSelectedPolyline);

        if (!bounds.isEmpty()) {
          this._fittingNow = true;
          this.skipNextAutoFit = true;

          gl.fitBounds(bounds, {
            padding: fitPadding,
            duration: durationSingle,
            linear: false,
            easing: t => 1 - Math.pow(1 - t, 2)
          });

          gl.once("moveend", () =>
            setTimeout(() => {
              this._fittingNow = false;
              this.skipNextAutoFit = false;
            }, 100)
          );
          moved = true;
        }
      }

      if (geometry.type === "Polygon") {
        geometry.coordinates.forEach(ring => ring.forEach(c => bounds.extend(c)));
      }

      if (geometry.type === "MultiPolygon") {
        geometry.coordinates.forEach(poly => poly.forEach(ring => ring.forEach(c => bounds.extend(c))));
      }

      if (!moved && !bounds.isEmpty()) {
        this._fittingNow = true;
        this.skipNextAutoFit = true;

        gl.fitBounds(bounds, {
          padding: fitPadding,
          duration: durationSingle,
          linear: false,
          easing: t => 1 - Math.pow(1 - t, 2)
        });

        gl.once("moveend", () =>
          setTimeout(() => {
            this._fittingNow = false;
            this.skipNextAutoFit = false;
          }, 100)
        );
      }
    },

    renderPoisAndFocus(poisGeoJSON) {
      const ctx = this.addPoisOn3DMap(poisGeoJSON);
      this.focusMapAfterAdding(ctx, {
        paddingMulti: 150,
        durationMulti: 1000,
        paddingSingle: 100,
        durationSingle: 1600
      });
    },

    async focusOnPoi(feature) {
      const safe = this.normalizeFeatureCollection(feature);
      if (!safe || !safe.features.length) return;
      feature = safe.features[0];

      if (!this.mtkMap || !feature?.geometry?.coordinates) {
        console.warn("WeatherMTK: Map or feature is missing");
        return;
      }

      this.clearPOIsFromMap(false);
      await this.$nextTick();
      this.skipNextAutoFit = false;
      setTimeout(() => {
        this.addPoisOn3DMap({
          type: "FeatureCollection",
          features: [feature]
        });
      }, 100);
    },
    _canAutoMoveCamera(reason = "") {
      if (this.cameraBusy) {
        console.log("[cam] BUSY → skip", {reason});
        return false;
      }
      if (this.skipNextAutoFit) {
        console.log("[cam] skipNextAutoFit → skip", {reason});
        this.skipNextAutoFit = false;
        return false;
      }
      return true;
    },
    _withCameraLock(doMove) {
      if (this.cameraBusy) return;
      this.cameraBusy = true;
      try {
        const ret = doMove?.();
        requestAnimationFrame(() => {
          this.cameraBusy = false;
        });
        return ret;
      } catch (e) {
        this.cameraBusy = false;
        throw e;
      }
    },

    clearPOIsFromMap() {
      // if (!this.mtkMap || typeof this.mtkMap.getLayers !== "function") {
      //   console.warn(" mtkMap or getLayers is not available");
      //   return;
      // }
      if (!this.mtkMap) return;
      this.poiLayer?.off?.("mouseover");
      this.poiLayer?.off?.("mouseout");
      this.geometryLineLayer?.off?.("mouseover");
      this.geometryLineLayer?.off?.("mouseout");
      this.geometryPolygonLayer?.off?.("mouseover");
      this.geometryPolygonLayer?.off?.("mouseout");
      if (this.poiLayer) {
        this.poiLayer.remove();
        this.poiLayer = null;
      }

      if (this.geometryLineLayer) {
        this.geometryLineLayer.remove();
        this.geometryLineLayer = null;
      }
      if (this.geometryPolygonLayer) {
        this.geometryPolygonLayer.remove();
        this.geometryPolygonLayer = null;
      }
      if (this.flightPolylineLayer) {
        this.flightPolylineLayer.remove();
        this.flightPolylineLayer = null;
      }

      this.isSingleLineSelected = false;
      if (this.hnrMarker3D) {
        this.hnrMarker3D.remove();
        this.hnrMarker3D = null;
      }
      if (this.startMarker3D) {
        this.startMarker3D.remove();
        this.startMarker3D = null;
      }
      if (this.stopMarker3D) {
        this.stopMarker3D.remove();
        this.stopMarker3D = null;
      }
      if (this.streetLineLayer3D) {
        this.streetLineLayer3D.remove();
        this.streetLineLayer3D = null;
      }
      if (this.currentSelectedPolyline) {
        this.currentSelectedPolyline.remove();
        this.currentSelectedPolyline = null;
      }

      //       if (this.geolocationMarker) {
      //   try { this.geolocationMarker.remove?.(); } catch (e){console.warn("Failed to remove geolocation marker", e);}
      //   this.geolocationMarker = null;
      // }
      this.removeMtkClusterLayer();
      this.removeMtkClusterLayer?.();
      this.removeMtkPoiLayer?.();
      this.removeMtkGeometryLayers?.();
    },
    close3DMapWeather() {
      if (this.mtkMap?.gl) {
        const center = this.mtkMap?.gl.getCenter();
        const zoom = this.mtkMap?.gl.getZoom();
        console.log("close3DMapWeather =>> Coordinates sent on map close:", {
          lat: center.lat,
          lng: center.lng,
          zoom
        });

        this.$emit("close3D", {
          lat: center.lat,
          lng: center.lng,
          zoom
        });
      } else {
        this.$emit("close3DWeather");
      }
      this.isWeatherLayerMounted = false;
      this.$emit("closeWeather");
    },
    getCurrentView() {
      const gl = this.mtkMap?.gl;
      if (!gl) return null;
      const c = gl.getCenter();
      console.log(c);
      return {lat: c.lat, lng: c.lng, zoom: gl.getZoom()};
    },
    async loadAllPoisFromBackend() {
      try {
        const base = M2wApi.host_address.replace(/\/+$/, "");
        const response = await fetch(`${base}/api/pois`);

        const contentType = response.headers.get("content-type");
        const raw = await response.text();

        if (!response.ok) {
          console.error(`Error HTTP ${response.status}:`, raw);
          throw new Error("Server response is not OK.");
        }

        if (!contentType || !contentType.includes("application/json")) {
          console.error("Response is not valid JSON. Type:", contentType);
          console.warn("Raw response received:", raw);
          throw new Error("Response is not of type JSON.");
        }

        let allPois = JSON.parse(raw);

        if (!allPois || allPois.type !== "FeatureCollection") {
          console.warn("Invalid POI data:", allPois);
          return;
        }

        const BASE_ICON_URL = M2wApi.host_address;
        const features = allPois.features.map(feature => {
          const rawIconId = feature.properties?.icon_id || feature.properties?.icon || null;
          const safeIconId = rawIconId ? rawIconId.replace(/^.*[\\/]/, "") : null;

          let iconUrl = null;
          if (feature.properties?.icon) {
            iconUrl = feature.properties.icon.startsWith("http")
              ? feature.properties.icon
              : BASE_ICON_URL + feature.properties.icon;
          }

          return {
            ...feature,
            properties: {
              ...feature.properties,
              icon: iconUrl,
              icon_id: safeIconId
            }
          };
        });

        allPois = {
          type: "FeatureCollection",
          features
        };
        this.addPoisOn3DMap(allPois);
        console.log("apelare addPois din functia loadAllpois");
      } catch (error) {
        console.error(" Failed to load POIs from backend:", error);
      }
    },
    startRouting() {
      console.log("Start Routing...");
    },
    triggerGeolocation() {
      const mtkMap = this.mtkMap;
      if (!mtkMap || !mtkMap.gl) {
        console.warn("MTK map is not ready or missing .gl reference");
        return;
      }

      if (this.geolocationMarker) {
        try {
          this.geolocationMarker.remove?.();
        } catch (e) {
          console.warn("Failed to remove geolocation marker:", e);
        }
        this.geolocationMarker = null;
        return;
      }

      const maplibregl = window.maplibregl || window.MTK?.maplibregl;
      if (!maplibregl) {
        console.error("maplibregl is not available");
        return;
      }

      navigator.geolocation.getCurrentPosition(
        pos => {
          const {latitude, longitude} = pos.coords;

          const sw = new maplibregl.LngLat(longitude - 0.01, latitude - 0.01);
          const ne = new maplibregl.LngLat(longitude + 0.01, latitude + 0.01);
          const bounds = new maplibregl.LngLatBounds(sw, ne);

          const marker = new MTK.LabeledMarker({
            title: "Locatia ta",
            subtitle: new Date().toLocaleTimeString()
          }).setLngLat([longitude, latitude]);

          marker.setImage({id: "marker", anchor: "bottom", size: 1});
          marker.addTo(mtkMap);
          this.geolocationMarker = marker;

          try {
            mtkMap.gl.fitBounds(bounds, {padding: 40, duration: 1000});
          } catch (err) {
            console.error("Error during fitBounds", err);
          }
        },
        err => {
          console.error("Geolocation error:", err);
        },
        {enableHighAccuracy: true}
      );
    },

    _showHoverTooltip(text, e) {
      if (!text) return;

      // MTK / MapLibre trimit uneori event-ul în originalEvent
      const oe = e?.originalEvent || e;

      const x = oe?.clientX ?? 0;
      const y = oe?.clientY ?? 0;

      this.hoverTooltip.text = text;
      this.hoverTooltip.x = x + 12; // mic offset față de cursor
      this.hoverTooltip.y = y + 12;
      this.hoverTooltip.visible = true;

      // cursor pointer
      const canvas = this.mtkMap?.gl?.getCanvas?.();
      if (canvas) canvas.style.cursor = "pointer";
    },

    _moveHoverTooltip(e) {
      if (!this.hoverTooltip.visible) return;

      const oe = e?.originalEvent || e;
      const x = oe?.clientX ?? 0;
      const y = oe?.clientY ?? 0;

      this.hoverTooltip.x = x + 12;
      this.hoverTooltip.y = y + 12;
    },

    _hideHoverTooltip() {
      this.hoverTooltip.visible = false;

      const canvas = this.mtkMap?.gl?.getCanvas?.();
      if (canvas) canvas.style.cursor = "";
    },

    //icon
    getDatabasePoiIconUrl(feature) {
      const rawIcon = feature?.properties?.icon || feature?.properties?.icon_url || feature?.properties?.marker || null;

      if (!rawIcon) {
        return null;
      }

      if (rawIcon.startsWith("http://") || rawIcon.startsWith("https://") || rawIcon.startsWith("data:")) {
        return rawIcon;
      }

      const host = String(M2wApi.host_address || "https://map.map2web.eu").replace(/\/+$/, "");

      const path = String(rawIcon).startsWith("/") ? rawIcon : `/${rawIcon}`;

      return `${host}${path}`;
    },
    getDatabasePoiIconId(feature, index = 0) {
      const rawId = feature?.properties?.icon_id || feature?.properties?.id || feature?.id || index;

      return `db-poi-icon-${String(rawId).replace(/[^a-zA-Z0-9_-]/g, "-")}`;
    },

    loadMtkPoiImage(gl, iconId, iconUrl) {
      return new Promise(resolve => {
        if (!gl || !iconId || !iconUrl) {
          resolve(false);
          return;
        }

        if (gl.hasImage?.(iconId)) {
          resolve(true);
          return;
        }

        gl.loadImage(iconUrl, (error, image) => {
          if (error || !image) {
            console.warn("[MTK cluster] Iconul nu a putut fi încărcat:", iconUrl, error);

            resolve(false);
            return;
          }

          try {
            if (!gl.hasImage?.(iconId)) {
              gl.addImage(iconId, image);
            }

            resolve(true);
          } catch (addError) {
            console.warn("[MTK cluster] Iconul nu a putut fi adăugat:", iconId, addError);

            resolve(false);
          }
        });
      });
    }
  }
};

function installNoZoomWhileDragging(gl, getZoom, setZoom) {
  let dragging = false;
  let zoomAtDragStart = null;
  const disableZoomers = () => {
    gl.scrollZoom.disable();
    // gl.touchZoomRotate.disable();
    gl.doubleClickZoom.disable();
    gl.boxZoom.disable();
  };
  const enableZoomers = () => {
    gl.scrollZoom.enable();
    // gl.touchZoomRotate.enable();
    gl.doubleClickZoom.enable();
    gl.boxZoom.enable();
  };

  gl.on("dragstart", () => {
    dragging = true;
    zoomAtDragStart = getZoom();
    disableZoomers();
  });

  gl.on("dragend", () => {
    dragging = false;
    enableZoomers();
    const z = getZoom();
    if (Math.abs(z - zoomAtDragStart) > 1e-6) setZoom(zoomAtDragStart);
  });

  gl.on("zoomstart", () => {
    if (dragging) {
      gl.stop();
      setZoom(zoomAtDragStart);
    }
  });
}

function installPanFlags(gl, setFlag) {
  gl.on("dragstart", () => setFlag(true));
  gl.on("dragend", () => setFlag(false));
}
</script>

<style scoped>
.zoom-indicator {
  position: absolute;
  top: 160px;
  right: 15.5px;
  z-index: 10000;
  width: 88px;
  text-align: center;
  pointer-events: none;
  background: rgba(236, 240, 243, 0.95);
  border: 1px solid #a9a9a9;
  box-shadow: 1px 3px 3px #999999;
  border-radius: 8px;
  padding: 5px 7px;
  font-family: Quicksand, sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #464646;
}
/* proiect pnrr */
/* .zoom-indicator {
  position: absolute;
  top: 235px;
  right: 15.5px;
  z-index: 10000;
  width: 88px;
  text-align: center;
  pointer-events: none;
  background: rgba(236, 240, 243, 0.95);
  border: 1px solid #a9a9a9;
  box-shadow: 1px 3px 3px #999999;
  border-radius: 8px;
  padding: 5px 7px;
  font-family: Quicksand, sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #464646;
} */
@media (max-width: 768px) {
  .zoom-indicator {
    position: absolute;
    top: auto;
    bottom: 0px;
    padding: 2.5px 5px;
    right: 12px;
  }
}

#weather-map-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: #000;
  pointer-events: auto;
}

#weather-map-container {
  width: 100%;
  height: 100%;
  pointer-events: auto;
}

.weather-icon-button {
  position: absolute;
  bottom: 10px;
  right: 15px;
  z-index: 1000;
  background-color: #ffffff;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
}

.weather-icon-button:hover {
  background-color: rgb(255, 255, 255);
}

.weather-icon-button .material-icons-round {
  font-size: 24px;
}
/* #weather-map-container {
  background-color: #87CEFA !important; 
  background: linear-gradient(to bottom, #a3d8fd 0%, #b0e2ff 10%, #f0f8ff 30%) !important;
} */

#weather-map-container {
  transition: background 0.6s ease-in-out;
}

.hover-tooltip {
  position: fixed;
  z-index: 99999;
  pointer-events: none;
  background: #ecf0f3;
  padding: 6px 10px;
  border: 1px solid #a9a9a9;
  box-shadow: 1px 3px 3px #999999;
  border-radius: 8px;
  /* max-width: 260px; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-family: Quicksand, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #464646;
  line-height: 1.2em;
  letter-spacing: 0.03em;
  text-align: left;
  flex: 1;
}
</style>

<style>
#weather-map-wrapper.is-embedded #weather-map-container .maplibregl-ctrl-bottom-right {
  margin-bottom: 90px !important;
  /* margin-right: 5px !important; */
}
#weather-map-container .mtk-control-styles-top-right {
  margin-top: 70px;
  margin-right: 15px;
  z-index: 10;
}

/* proiect pnrr */
/* #weather-map-container .mtk-control-styles-top-right {
  margin-top: 145px;
  margin-right: 15px;
  z-index: 10;
} */
@media (max-width: 768px) {
  #weather-map-container .mtk-control-styles-top-right {
    display: none !important;
  }
}

#weather-map-container .maplibregl-canvas-container {
  background-color: #87cefa !important;
}

#weather-map-container .maplibregl-ctrl-attrib-inner {
  display: none;
}

#weather-map-container .mtk-control-logo {
  display: none;
}

@media (max-width: 768px) {
  #weather-map-container .mapboxgl-ctrl-attrib {
    display: none !important;
  }
}

#weather-map-container .maplibregl-ctrl-bottom-right {
  /* frontend2-base dezactivat stilul de mai jos*/
  /* margin-bottom: 205px; */
  /* frontend2-base activat stilul de mai jos*/
  margin-bottom: 165px;
  /* proiect pnrr  */
  /* margin-bottom: 280px; */
  margin-right: -6px;
  z-index: 10;
}
/* proiect pnrr */
/* #weather-map-container .maplibregl-ctrl-bottom-center {
  bottom: 80px;
} */
/* proiect pnrr */
/* @media (min-width: 400px) and (max-width: 769px) {
  #weather-map-container .mtk-3d-control {
    background-color: #ecf0f3;
    margin-bottom: 20px;
  }
} */
#weather-map-container .mtk-3d-control {
  background-color: #ecf0f3;
  border: 1px solid #a9a9a9;
  box-shadow: 1px 3px 3px #999999;
  margin-bottom: 20px;
  border-radius: 8px;
}

@media (max-width: 599px) {
  #weather-map-container .maplibregl-ctrl-bottom-right {
    /* margin-bottom: 175px; */
      /* frontend2-base activat stilul de mai jos*/
  margin-bottom: 140px;
  }
}
/* proiect pnrr */
/* @media (max-width: 599px) {
  #weather-map-container .maplibregl-ctrl-bottom-right {
    margin-bottom: 250px;
  }
} */

#weather-map-container .mtk-control-styles-current {
  font-family: Quicksand, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #464646;
  line-height: 1.2em;
  letter-spacing: 0.03em;
  text-align: left;
  flex: 1;
}

#weather-map-container .mtk-control-styles-groups-active {
  font-family: Quicksand, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #464646;
  line-height: 1.2em;
  letter-spacing: 0.03em;
  text-align: left;
  flex: 1;
}

#weather-map-container .mtk-control-styles-group-list-item-name {
  font-family: Quicksand, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #464646;
  line-height: 1.2em;
  letter-spacing: 0.03em;
  text-align: left;
  flex: 1;
}

#weather-map-container .mtk-control-styles-expand {
  font-family: Quicksand, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #464646;
  line-height: 1.2em;
  letter-spacing: 0.03em;
  text-align: left;
  flex: 1;
}
#weather-map-container .mtk-control-styles-groups-active {
  padding: 0px;
  border: 1px solid #a9a9a9;
  box-shadow: 1px 3px 3px #9999;
}

#weather-map-container .mtk-control-styles {
  border: 1px solid #a9a9a9;
  box-shadow: 1px 3px 3px #9999;
}

#weather-map-container .mtk-weather-control-group {
  display: none;
  margin-top: 30px;
  margin-right: 15px;
  padding: 3.3px;
  border-radius: 10px;
  z-index: 10;
  border: 1px solid #a9a9a9;
  box-shadow: 1px 3px 3px #9999;
}

@media (max-width: 768px) {
  #weather-map-container .mtk-weather-control-group {
    display: none !important;
  }
}

#weather-map-container .mtk-scale-control {
  display: none !important;
  margin-right: 15px;
  border-radius: 10px;
}

#weather-map-container .mtk-elevation-svg {
  display: none;
  /* background-color: aqua; */
}
#weather-map-container .mtk-compass-control-label {
  font-family: Quicksand, sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #464646;
  line-height: 1.2em;
  letter-spacing: 0.03em;
  text-align: center;
  flex: 1;
}

#weather-map-container .mtk-3d-control button {
  font-family: Quicksand, sans-serif;
  background-color: #ecf0f3;
  padding: 20px 20px;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.2;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  color: #444;
  display: flex;
  align-items: center;
  justify-content: center;
}

#weather-map-container .mtk-daytime-control .mtk-daytime-control-0-button {
  font-family: Quicksand, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #464646;
  line-height: 1.2em;
  letter-spacing: 0.03em;
  text-align: left;
  flex: 1;
}

#weather-map-container .mtk-daytime-control .mtk-daytime-control-1-button {
  font-family: Quicksand, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #464646;
  line-height: 1.2em;
  letter-spacing: 0.03em;
  text-align: left;
  flex: 1;
}
#weather-map-container .mtk-daytime-control .mtk-daytime-control-2-button {
  font-family: Quicksand, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #464646;
  line-height: 1.2em;
  letter-spacing: 0.03em;
  text-align: left;
  flex: 1;
}
#weather-map-container .mtk-daytime-control .mtk-daytime-control-3-button {
  font-family: Quicksand, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #464646;
  line-height: 1.2em;
  letter-spacing: 0.03em;
  text-align: left;
  flex: 1;
}
#weather-map-container .mtk-daytime-control .mtk-daytime-control-4-button {
  font-family: Quicksand, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #464646;
  line-height: 1.2em;
  letter-spacing: 0.03em;
  text-align: left;
  flex: 1;
}

#weather-map-container .mtk-daytime-control {
  font-family: Quicksand, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #464646;
  line-height: 1.2em;
  letter-spacing: 0.03em;
  text-align: left;
  flex: 1;
  border: 1px solid #a9a9a9;
  box-shadow: 1px 3px 3px #9999;
}

#weather-map-container .mtk-compass-control {
  margin-top: 70px;
  margin-right: 15px;
  background-color: #ecf0f3;
  font-family: Quicksand, sans-serif;
}

#weather-map-container .mtk-pitch-control .mtk-pitch-control-slide {
  background-color: #ecf0f3;
  font-family: Quicksand, sans-serif;
}
@media (max-width: 768px) {
  #weather-map-container .mtk-pitch-control {
    display: none !important;
  }
}

@media (max-width: 768px) {
  #weather-map-container .mtk-3d-control {
    background-color: #ecf0f3;
    border: 1px solid #a9a9a9;
    box-shadow: 1px 3px 3px #999999;
    margin-bottom: 25px;
    border-radius: 8px;
  }
}

#weather-map-container .maplibregl-ctrl-group-inline {
  background-color: #ecf0f3;
  padding: 3.3px;
  border-radius: 10px;
  box-shadow: 0 0 0 0px rgba(0, 0, 0, 0) !important;
}
.maplibregl-ctrl-group:not(:empty) {
  box-shadow: 0 0 0 0px rgba(176, 6, 6, 0.1);
}

#weather-map-container .mtk-control-flight-button .mtk-control-flight {
  display: none;
  /* margin-top: 170px; */
}

#weather-map-container .mtk-control-flight {
  /* margin-top: 170px; */
  /* display: none; */
}

/* @media (max-height: 700px), (max-width: 500px) {
  #weather-map-container .mtk-control-styles-current {
    display: none !important;
  }
} */
@media (max-height: 700px), (max-width: 500px) {
  #weather-map-container .mtk-pitch-control {
    display: none !important;
  }
  #weather-map-container .maplibregl-ctrl-attrib-button {
    display: none;
  }
  #weather-map-container .maplibregl-compact-show {
    background: none;
  }
}
@media (max-height: 760px), (max-width: 500px) {
  #weather-map-container .mtk-pitch-control {
    display: none !important;
  }
  #weather-map-container .maplibregl-ctrl-attrib-button {
    display: none;
  }
  #weather-map-container .maplibregl-compact-show {
    background: none;
  }
}

@media (orientation: landscape) and (max-width: 900px) {
  #weather-map-container .mtk-3d-control,
  #weather-map-container .mtk-compass-control,
  #weather-map-container .mtk-pitch-control,
  #weather-map-container .mtk-control-styles,
  #weather-map-container .mtk-daytime-control,
  #weather-map-container .mtk-weather-control-group,
  #weather-map-container .maplibregl-ctrl-bottom-right,
  #weather-map-container .maplibregl-ctrl-top-right {
    display: none !important;
  }
}

.flight-host .mtk-control-flight {
  display: block !important;
}
.panorama-hover {
  position: absolute;
  z-index: 9999;
  /* width: 42px;
  height: 42px; */
  transform: translate(-50%, -100%);

  cursor: pointer;
  /* background: white; */
  border-radius: 8px;
  padding: 5px;

  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35); */
}

.panorama-hover img {
  display: block;

  width: 42px;
  height: 42px;

  object-fit: contain;
}

.mtk-control-flight-button {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;

  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  min-height: 36px !important;

  padding: 0 !important;
  margin: 0 !important;
  box-sizing: border-box !important;

  background: #ecf0f3 !important;
  border: 1px solid #a9a9a9 !important;
  box-shadow: 1px 3px 3px #999999 !important;
  border-radius: 8px !important;

  cursor: pointer;
  line-height: 1;
}

.mtk-control-flight-button:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08) !important;
}

.mtk-control-flight-button:active {
  transform: translateY(1px);
}

.mtk-control-flight-button .maplibregl-ctrl-icon {
  display: block !important;
  width: 24px !important;
  height: 24px !important;

  padding: 0 !important;
  margin: 0 !important;

  border: 0 !important;
  box-shadow: none !important;

  background-color: transparent !important;
  background-size: 20px 20px !important;
  background-position: center !important;
  background-repeat: no-repeat !important;

  transform: none !important;
}
/* SF selectat / activ */
.mtk-sf-overlay-item.mtk-sf-active .mtk-control-styles-group-list-item-image {
  border: 2px solid #222 !important;
  border-radius: 9px !important;
  box-sizing: border-box;
}

/* SF oprit */
.mtk-sf-overlay-item:not(.mtk-sf-active) .mtk-control-styles-group-list-item-image {
  border: none !important;
}
/* =====================================================
   PANORAMA ACTIVE
   Ascunde toate controalele MTK din spatele panoramei
   ===================================================== */

body.panorama-active #weather-map-wrapper .zoom-indicator,
body.panorama-active #weather-map-wrapper .panorama-hover,
body.panorama-active #weather-map-wrapper .sf-overlay-control,
body.panorama-active #weather-map-wrapper #routing-button,
body.panorama-active #weather-map-container .mtk-3d-control,
body.panorama-active #weather-map-container .mtk-compass-control,
body.panorama-active #weather-map-container .mtk-pitch-control,
body.panorama-active #weather-map-container .mtk-control-styles,
body.panorama-active #weather-map-container .mtk-daytime-control,
body.panorama-active #weather-map-container .mtk-weather-control-group,
body.panorama-active #weather-map-container .maplibregl-ctrl-top-right,
body.panorama-active #weather-map-container .maplibregl-ctrl-bottom-right,
body.panorama-active #weather-map-container .maplibregl-ctrl-top-left,
body.panorama-active #weather-map-container .maplibregl-ctrl-bottom-left {
  display: none !important;
}
/* TABLET */
/* @media (min-width: 769px) and (max-width: 1000x) {
  .zoom-indicator {
    display: none !important;
  }
} */
</style>
